<template>
  <div>

    <!-- E-arsiv bilgi girisi. Ayni dialog faturakopya.vue'da da vardi. -->
    <v-dialog v-model="dialogearsiv" scrollable="" persistent="" max-width="400px">
        <v-card color="grey lighten-5">
            <v-card-title> {{ $t('E-Archive-Information-Entry') }} </v-card-title>
            <v-divider></v-divider>
            <v-card-text>

                <v-flex xs12 sm12 md12 style=" padding-bottom:10px;">
                    <v-card class="white--text">
                        <v-card flat="">
                            <v-card-actions>

                                <v-layout row="" wrap="">
                                    <div class="flex md12">

                                        <v-select :items="gonderimsekli" hide-details="" v-model="SerbestFatura.EarsivBilgi.GonderimSekli" :label="$t('Sending-Method')" item-text="text" item-value="value" max-height="400"></v-select>

                                        <v-select v-model="SerbestFatura.EarsivBilgi.InternetSatis" hide-details="" :items="odemesekli" :label="$t('Internet-Sales')" item-text="text" item-value="value" max-height="400" persistent-hint>
                                        </v-select>

                                        <v-select :items="webadresleri" hide-details="" v-model="SerbestFatura.EarsivBilgi.WebAdresi" :label="$t('Web-Address')" item-text="Aciklama" clearable item-value="ID" max-height="400"></v-select>

                                        <v-select :items="odemesekli1" hide-details="" v-model="SerbestFatura.EarsivBilgi.OdemeSekli" :label="$t('Payment-Method')" item-text="text" clearable item-value="value" max-height="400"></v-select>

                                        <v-select :items="odemesekilleri" hide-details="" v-model="SerbestFatura.EarsivBilgi.OdemeSekliAciklama" :label="$t('Payment-Method-Description')" item-text="Aciklama" clearable item-value="ID" max-height="400"></v-select>

                                        <v-select :items="odemearaci" hide-details="" v-model="SerbestFatura.EarsivBilgi.OdemeAraci" :label="$t('Payment-Instrument')" item-text="Aciklama" clearable item-value="ID" max-height="400" persistent-hint></v-select>

                                        <tarihcomp :etiket="$t('Payment-Date')" hide-details="" :tabindex="'17'" v-bind:value="SerbestFatura.EarsivBilgi.OdemeTarihi" v-model="SerbestFatura.EarsivBilgi.OdemeTarihi"></tarihcomp>

                                    </div>
                                </v-layout>
                            </v-card-actions>
                        </v-card>
                    </v-card>
                </v-flex>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="dialogearsiv=false">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="dialogearsiv=false">{{$t("save_button")}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <!-- Satir silme onayi. Kaynakta sayfanin ortak "dialogsor"u
         kullaniliyordu; satir silme buraya tasindigi icin onay da
         bilesene tasindi. Fatura silme onayi asagida (faturasilonayi). -->
    <v-dialog v-model="dialogsor" persistent max-width="290">
        <v-card>
            <v-card-title class="headline">{{ $t('Warning') }} !</v-card-title>
            <v-card-text>{{ $t('Are-you-sure-you-want-to-delete-this-record') }}</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="info" flat @click.native="dialogsor=false">{{$t("cancel_button")}}</v-btn>
                <v-btn data-test="sf-satir-sil-onay" v-if="satirsilbtn" :disabled="satirSiliniyor" :loading="satirSiliniyor" color="info" flat @click="satirsil()">{{ $t('OK') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <!-- Yukleme penceresi. Durum sayfada: sayfanin loadingdialog'u (kaydet, guncelle, iade,
         fatura yukleme) `yukleniyor` ile gelir. Iki sayfada birebir ayniydi. -->
    <v-dialog :value="yukleniyor" hide-overlay persistent width="300">
        <v-card color="primary" dark>
            <v-card-text>
                {{ $t('Your-invoice-information-being-prepared') }}, {{ $t('Please-Wait') }}
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>

    <!-- Fatura silme onayi. Acma/kapama sayfada (dialogsor, `faturasilonayi.sync`);
         silme istegini OK uzerine sayfanin faturasil()'i yapar (`faturasilislemi` prop'u; OK
         butonu kaydetbutonu, islemin Promise'ini bekler). -->
    <v-dialog :value="faturasilonayi" persistent max-width="290">
        <v-card>
            <v-card-title class="headline">{{ $t('Warning') }} !</v-card-title>
            <v-card-text>{{ $t('Are-you-sure-you-want-to-delete-this-record') }}</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="info" flat @click.native="$emit('update:faturasilonayi', false)">{{$t("cancel_button")}}</v-btn>
                <kaydetbutonu data-test="sf-fatura-sil-onay" color="info" :action="faturasilislemi">{{ $t('OK') }}</kaydetbutonu>
            </v-card-actions>
        </v-card>
    </v-dialog>

                <v-container fluid>
                    <v-layout row wrap>

                        <v-flex pa-1 xs12 sm12 md6>
                            <!-- CARI: secim, yeni cari ekleme (+) ve cari bilgileri ortak caricomp bileseninde
                                 (carihareketler ve bilet ekranlari da kullaniyor). Cari bilgisini (Current/Get)
                                 YALNIZCA caricomp getirir; faturaya ozel isler -- e-fatura bilgisi, vade, masraf
                                 merkezi, gonderim sekli, GiB serisi -- onun sendCurrentInfo olayinda
                                 cariBilgisiGeldi() ile yapilir. -->
                            <caricomp ref="cari" data-test="sf-cari"
                                v-model="SerbestFatura.Cari.Kod"
                                :aktifmi="yazdirbtngoster || $route.query.islem === 'gelenevrak'"
                                @sendCurrentInfo="cariBilgisiGeldi"></caricomp>

                            <v-flex mt-2 xs12 sm12 md12>
                                <v-card flat class="white--text">
                                    <v-card flat="">
                                        <v-card-actions>
                                            <v-layout row wrap>
                                                <v-flex xs12 sm6 md6>
                                                    <v-autocomplete data-test="sf-fatura-tipi" :items="faturatipi" clearable hide-details="" v-model="SerbestFatura.FaturaTip" @change="$emit('faturatipisecildi', $event)" item-text="text" item-value="value" :label="this.$t('Invoice-Type')"></v-autocomplete>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <v-autocomplete hide-details="" :items="EvrakTipi1" v-bind="EvrakTipi1" item-text="Title" v-model="SerbestFatura.Evrak.Evrakkod" clearable item-value="Evrakkod" :label="this.$t('Document-Type')">
                                                    </v-autocomplete>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <referansmerkezicomp :coper="false" v-model="SerbestFatura.Referans.Kod"></referansmerkezicomp>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <masrafmerkezicomp v-model="SerbestFatura.Masraf.Code"></masrafmerkezicomp>
                                                </v-flex>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm6 md6>
                                                        <v-autocomplete data-test="sf-doviz-cinsi" :items="doviztipi" clearable hide-details="" item-text="Title" item-value="DovizKod" v-model="SerbestFatura.Doviz.DovizKod" @change="dovizSecildi" :label="$t('Type-of-currency')"></v-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs12 sm6 md6>
                                                        <dovizinput data-test="sf-kur" v-model="SerbestFatura.Kur" :etiket="$t('Exchange-Entry')" ::autocomplete="autocomplete">
                                                        </dovizinput>
                                                    </v-flex>
                                                    <v-flex xs12 sm6 md6>
                                                        <v-text-field v-model="SerbestFatura.Aciklama" maxlength="250" hide-details="" :label="$t('Description')" value="">
                                                        </v-text-field>
                                                    </v-flex>
                                                    <v-checkbox data-test="sf-dovizli" v-model="SerbestFatura.Dovizli" :label="$t('Foreign-Currency-Invoice')" hide-details>
                                                    </v-checkbox>
                                                </v-layout>
                                            </v-layout>
                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-flex>
                        </v-flex>

                        <v-flex pa-1 xs12 sm6 md3>
                            <v-card flat v-if="SerbestFatura.Earchiveakayit==true || SerbestFatura.Efaturakayit==true" class="white--text">
                                <v-card flat="">
                                    <v-card-actions>
                                        <v-layout row wrap>
                                            <v-layout v-if="SerbestFatura.Earchiveakayit" row wrap>
                                                <v-flex xs12 sm12 md12>
                                                    <v-toolbar flat="" size="120px" dark color="green">
                                                        <v-toolbar-title> {{$t('E-archiveinfo_header')}} </v-toolbar-title>
                                                        <v-spacer></v-spacer>
                                                        <kaydetbutonu fab flat color="" :action="earsivbilgigir">
                                                            <v-icon right dark>edit</v-icon>
                                                        </kaydetbutonu>
                                                    </v-toolbar>
                                                </v-flex>

                                                <v-flex xs12 sm12 md12>
                                                    <v-layout row wrap>
                                                        <v-flex xs12 sm6 md5>
                                                            <span class="body-1 font-weight-thin grey--text mb-2">
                                                                 {{ $t('Sending-Method') }} :
                                                            </span>
                                                        </v-flex>
                                                        <v-flex xs12 sm6 md7>
                                                            <span class="body-1 font-weight-thin grey--text mb-2">
                                                                {{gonderimlabel}}
                                                            </span>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>

                                                <v-flex xs12 sm12 md12>
                                                    <v-layout row wrap>
                                                        <v-flex xs12 sm6 md5>
                                                            <span class="body-1 font-weight-thin grey--text mb-2">
                                                                 {{ $t('Internet-Sales') }} :
                                                            </span>
                                                        </v-flex>
                                                        <v-flex xs12 sm6 md7>
                                                            <span class="body-1 font-weight-thin grey--text mb-2">
                                                                {{internetsatislabel}}
                                                            </span>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>

                                                <v-flex xs12 sm12 md12>
                                                    <v-layout row wrap>
                                                        <v-flex xs12 sm6 md5>
                                                            <span class="body-1 font-weight-thin grey--text mb-2">
                                                                {{ $t('Web-Address') }} :
                                                            </span>
                                                        </v-flex>
                                                        <v-flex xs12 sm6 md7>
                                                            <span class="body-1 font-weight-thin grey--text mb-2">
                                                                {{webadresilabel}}
                                                            </span>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                                <v-flex xs12 sm12 md12>
                                                    <v-layout row wrap>
                                                        <v-flex xs12 sm6 md5>
                                                            <span class="body-1 font-weight-thin grey--text mb-2">
                                                                {{ $t('Payment-Method') }} :
                                                            </span>
                                                        </v-flex>
                                                        <v-flex xs12 sm6 md7>
                                                            <span class="body-1 font-weight-thin grey--text mb-2">
                                                                {{odemeseklilabel}}
                                                            </span>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>

                                                <v-flex xs12 sm12 md12>
                                                    <v-layout row wrap>
                                                        <v-flex xs12 sm6 md5>
                                                            <span class="body-1 font-weight-thin grey--text mb-2">
                                                                {{$t('Payment-Method-Description')}}: </span>
                                                        </v-flex>
                                                        <v-flex xs12 sm6 md7>
                                                            <span class="body-1 font-weight-thin grey--text mb-2">
                                                                {{odemesekliaciklamalabel}}
                                                            </span>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>

                                                <v-flex xs12 sm12 md12>

                                                    <v-layout row wrap>
                                                        <v-flex xs12 sm6 md5>
                                                            <span class="body-1 font-weight-thin grey--text mb-2">
                                                                {{ $t('Payment-Instrument') }}: </span>
                                                        </v-flex>
                                                        <v-flex xs12 sm6 md7>
                                                            <span class="body-1 font-weight-thin grey--text mb-2">
                                                                {{odemearacilabel}}
                                                            </span>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>

                                                <v-flex xs12 sm12 md12>
                                                    <v-layout row wrap>
                                                        <v-flex xs12 sm6 md5>
                                                            <span class="body-1 font-weight-thin grey--text mb-2">
                                                                {{$t('Payment-Date')}}:</span>
                                                        </v-flex>
                                                        <v-flex xs12 sm6 md7>
                                                            <span class="body-1 font-weight-thin grey--text mb-2">
                                                                {{odemetarihilabel}}
                                                            </span>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout mt-2 v-if="SerbestFatura.Efaturakayit" row wrap>
                                                <v-flex xs12 sm12 md12>
                                                    <v-toolbar flat="" size="120px" dark color="red">
                                                        <v-toolbar-title> {{ $t('E-invoiceinfo_header') }} </v-toolbar-title>
                                                        <v-spacer></v-spacer>
                                                    </v-toolbar>
                                                </v-flex>
                                                <v-flex xs12 sm12 md12>
                                                    <v-select hide-details="" :items="efaturatipi" clearable v-model="efaturatipigecici" item-text="text" :disabled="true" item-value="value" :label="$t('E-invoicetype')"></v-select>
                                                </v-flex>
                                            </v-layout>

                                        </v-layout>
                                    </v-card-actions>
                                </v-card>
                            </v-card>
                        </v-flex>

                        <v-flex pa-1 xs12 sm6 md3>
                            <v-flex xs12 sm12 md12>
                                <v-card flat class="white--text">
                                    <v-card flat="">
                                        <v-card-actions>
                                            <v-layout row wrap>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm12 md12>

                                                        <tarihcomp data-test="sf-fatura-tarihi" :etiket="$t('Invoice-Date')" :aktifmi="guncellebuton" :detaygizle="true" :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'" v-bind:value="SerbestFatura.Tarih" v-model="SerbestFatura.Tarih"></tarihcomp>

                                                    </v-flex>
                                                    <v-flex xs12 sm12 md12>
                                                        <v-layout>
                                                            <v-flex xs12 sm6 md6>
                                                                <v-text-field data-test="sf-fatura-seri" :disabled="seridisable" mask="NNN" :label="$t('Invoice-Serial-No-v3')" :error-messages="errors.collect('faturaseri')" v-validate="'required'" data-vv-name="faturaseri" hide-details="" v-model="SerbestFatura.FaturaSeri" required></v-text-field>
                                                            </v-flex>
                                                            <v-flex xs12 sm6 md6 v-if="gibserigoster == false">
                                                                <v-text-field data-test="sf-fatura-no" hide-details="" mask="##################" :disabled="seridisable" :label="$t('Invoice-No')" :error-messages="errors.collect('faturano')" v-model.number="SerbestFatura.FaturaNo" v-validate="'required'" data-vv-name="faturano" required></v-text-field>
                                                            </v-flex>
                                                               <v-flex xs12 sm6 md6 v-if="gibserigoster == true">
                                                                <v-text-field data-test="sf-fatura-no" hide-details=""  mask="#########" :disabled="seridisable" :label="$t('Invoice-No')" :error-messages="errors.collect('faturano')" v-model.number="SerbestFatura.FaturaNo" v-validate="'required'" data-vv-name="faturano" required></v-text-field>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md12>
                                                        <tarihcomp :etiket="$t('Maturity')" :detaygizle="true" :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'" v-bind:value="SerbestFatura.Vade" v-model="SerbestFatura.Vade"></tarihcomp>

                                                    </v-flex>
                                                    <!-- <v-flex xs12 sm12 md12>
                                                        <v-select :items="Tevkifat" v-model="SerbestFatura.TevkivatKdv" item-text="text" hide-details="" item-value="value" @blur="anatevkifatiptal()" clearable="" label=" Tevkifat KDV" @change="anatevkifatkdvkontrol()"></v-select>
                                                    </v-flex> -->
                                                    <v-flex xs12 sm12 md12>
                                                        <v-select data-test="sf-gib-seri" v-if="gibserigoster" :items="gibseri" hide-details="" item-text="Seri" item-value="Seri" clearable v-model="SerbestFatura.GibSeri" :label="this.$t('Gib-Series')">
                                                        </v-select>
                                                    </v-flex>

                                                </v-layout>
                                            </v-layout>
                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-flex>

                            <v-flex xs12 v-if="dizayngoster" sm12 md12>
                                <v-card flat class="white--text">
                                    <v-card flat="">
                                        <v-card-actions>
                                            <v-layout row wrap>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm12 md12>
                                                        <v-toolbar flat="" size="120px" dark color="#9E9E9E">
                                                            <v-toolbar-title> {{ $t('Design-Selection') }} </v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                        </v-toolbar>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md12>
                                                        <v-layout row wrap>

                                                            <v-select data-test="sf-dizayn" :items="dizaynsec" @change="dizaynbilgigetir(SerbestFatura.EFaturaShowID.DizaynID)" v-model="SerbestFatura.EFaturaShowID.DizaynID" hide-details="" clearable item-text="FaturaAciklama" item-value="FaturaId" :label="$t('Select-Design')" :error-messages="errors.collect('dizayn')" v-validate="'required'" data-vv-name="dizayn" required></v-select>

                                                            <!-- <v-select :items="xsltitems" hide-details=""
                                  v-model="SerbestFatura.EFaturaShowID.XsltID" clearable item-text="XsltAciklama"
                                  item-value="FaturaId" :label="$t('Select-xslt-File')"
                                  :error-messages="errors.collect('xslt')" v-validate="'required'" data-vv-name="xslt"
                                  required></v-select> -->

                                                            <reportbrosablon v-show="reportbroview" ref="reportbrosablon" menudisable v-model="SerbestFatura.EFaturaShowID.PdfID" dizayngrupadi="Fatura" objectname="Controllers.ReportBro.Invoice.InvoicePrint">
                                                            </reportbrosablon>

                                                        </v-layout>
                                                    </v-flex>
                                                </v-layout>
                                            </v-layout>
                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-flex>

                        </v-flex>

                    </v-layout>

                    <v-flex mt-2 xs12 sm12 md12>
                        <v-card flat class="white--text">
                            <v-card flat="">
                                <v-card-actions>
                                    <v-layout row wrap>
                                        <v-flex xs12 sm12 md12>

                                            <v-toolbar flat="" size="120px" dark color="#9E9E9E">
                                                <v-toolbar-title>  {{ $t('Line-Entry') }}  </v-toolbar-title>
                                                <v-spacer></v-spacer>
                                                <v-btn data-test="sf-toplu-muhasebe-ac" v-show="kalemler.length > 0" :disabled="seciliKalemler.length === 0" @click="topluMuhasebeAc()" flat>{{ $t('Assign-Accounting-Code') }}<span v-if="seciliKalemler.length > 0">&nbsp;({{ seciliKalemler.length }})</span>
                                                    <v-icon color="white" right dark>playlist_add_check</v-icon>
                                                </v-btn>
                                                <v-btn data-test="sf-satir-ekle" @click="satirekle()" flat>{{ $t('Add-Line')}}
                                                    <v-icon color="white" right dark>add_box</v-icon>
                                                </v-btn>
                                            </v-toolbar>
                                        </v-flex>


<!-- Sutun basliklari (masaustu). Satirlarla ayni yerde durmali. -->
    <v-layout v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl" row="" wrap>
        <v-flex xs12 sm12 md12>
            <v-card flat color="grey lighten-5">
                <v-list>
                    <template>
                        <v-layout row wrap>
                            <v-flex xs12 sm2 md2>
                                <v-layout align-start justify-start row fill-height>
                                    <v-card flat="">
                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title> <span class='grey-text--primary caption '>
                                                       <input type="checkbox" data-test="sf-satir-tumunu-sec" :title="$t('Select-All-Lines')" :checked="tumuSecili" :indeterminate.prop="kismenSecili" :disabled="kalemler.length === 0" @change="tumunuSec($event.target.checked)" style="vertical-align:middle;margin:0 6px 0 0;cursor:pointer;accent-color:#1976d2;"><span class="grey--text" style="display:inline-block;min-width:22px;text-align:right;margin-right:6px;">#</span>{{ $t('EXPLANATION')}}
                                                    </span>
                                                </v-list-tile-sub-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                    </v-card>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 sm2 md2>
                                <v-layout align-start justify-end row fill-height>
                                    <v-card flat="">
                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title> <span class='grey-text--primary caption '>
                                                        {{$t('DISCOUNT')}}
                                                    </span>
                                                </v-list-tile-sub-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                    </v-card>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 sm2 md2>
                                <v-layout align-start justify-end row fill-height>
                                    <v-card flat="">
                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title> <span class='grey-text--primary caption '>
                                                        {{$t('TAXES')}}
                                                    </span>
                                                </v-list-tile-sub-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                    </v-card>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 sm1 md1>
                                <v-layout align-start justify-end row fill-height>
                                    <v-card flat="">
                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title> <span class='grey-text--primary caption '>
                                                        {{$t('VAT')}} %
                                                    </span>
                                                </v-list-tile-sub-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                    </v-card>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 sm2 md2>
                                <v-layout align-start justify-end row fill-height>
                                    <v-card flat="">
                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title> <span class='grey-text--primary caption '>
                                                        {{ $t('VAT') }}
                                                    </span>
                                                </v-list-tile-sub-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                    </v-card>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 sm2 md2>
                                <v-layout align-start justify-end row fill-height>
                                    <v-card flat="">
                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title> <span class='grey-text--primary caption '>
                                                        {{$t('AMOUNT')}}
                                                    </span>
                                                </v-list-tile-sub-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                    </v-card>
                                </v-layout>
                            </v-flex>
                            <v-flex sm1 md1>
                                <v-layout row align-end justify-start="">
                                    <v-card flat="">
                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title> <span class='grey-text--primary caption '>
                                                    </span>
                                                </v-list-tile-sub-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                    </v-card>
                                </v-layout>
                            </v-flex>
                        </v-layout>

                    </template>

                </v-list>

            </v-card>

        </v-flex>
        <v-flex xs12 sm12 md12>
            <v-divider></v-divider>
        </v-flex>
    </v-layout>

    <v-flex xs12 v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl" sm12 md12>
        <v-layout row="" wrap>
            <v-flex xs12 sm12 md12>
                <v-card flat>
                    <template v-for="(item, sira) in kalemler">
                        <!-- key: satir nesnelerinde `id` alani YOK (olculdu),
                             `item.id` her satirda undefined baglaniyordu. -->
                        <v-layout v-bind:key="sira" row wrap>

                            <v-flex xs12 sm2 md2>
                                <v-layout align-start justify-start="" row fill-height>
                                    <v-card flat="">
                                        <v-list-tile-content>
                                            <v-list-tile-sub-title> &nbsp; <span class='grey-text--primary caption '>
                                                    <input type="checkbox" data-test="sf-satir-sec" :checked="satirSeciliMi(item)" @change="satirSec(item, $event.target.checked)" style="vertical-align:middle;margin:0 6px 0 0;cursor:pointer;accent-color:#1976d2;"><span class="grey--text" style="display:inline-block;min-width:22px;text-align:right;margin-right:6px;">{{ sira + 1 }}</span>{{item.Aciklama}}
                                                </span>
                                            </v-list-tile-sub-title>
                                            <v-list-tile-sub-title v-if="item.MuhasebeKodu" data-test="sf-satir-muhasebe-kodu-goster" class="caption grey--text" style="padding-left:56px;">{{ item.MuhasebeKodu }}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-card>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 sm2 md2>
                                <v-layout align-start justify-end="" row fill-height>
                                    <v-card flat="">
                                        <v-list-tile-sub-title> &nbsp; <span class='grey-text--primary caption '>
                                                {{item.IskontoTutar | moneyformat}}{{getparabirimi()}}
                                            </span>
                                        </v-list-tile-sub-title>
                                    </v-card>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 sm2 md2>
                                <v-layout align-start justify-end="" row fill-height>
                                    <v-card flat="">
                                        <v-list-tile-sub-title> &nbsp; <span class='grey-text--primary caption '>
                                                {{item.TevkifatDetayTutar | moneyformat}}{{getparabirimi()}}
                                            </span>
                                        </v-list-tile-sub-title>
                                    </v-card>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 sm1 md1>
                                <v-layout align-start justify-end row fill-height>
                                    <v-card flat="">
                                        <v-list-tile-sub-title> &nbsp; <span class='grey-text--primary caption '>
                                                % {{item.KdvYuzde}}
                                            </span>
                                        </v-list-tile-sub-title>
                                    </v-card>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 sm2 md2>
                                <v-layout align-start justify-end="" row fill-height>
                                    <v-card flat="">
                                        <v-list-tile-sub-title> &nbsp; <span class='grey-text--primary caption '>
                                                {{item.KdvTutar | moneyformat}}{{getparabirimi()}}
                                            </span>
                                        </v-list-tile-sub-title>
                                    </v-card>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 sm2 md2>
                                <v-layout align-start justify-end row fill-height>
                                    <v-card flat="">
                                        <v-list-tile-sub-title> &nbsp; <span class='grey-text--primary caption '>
                                                {{item.Tutar | moneyformat}}{{getparabirimi()}}
                                            </span>
                                        </v-list-tile-sub-title>
                                    </v-card>
                                </v-layout>
                            </v-flex>
                            <v-flex sm1 md1>
                                <v-layout row align-center justify-center="">
                                    <v-card flat="">
                                        <v-layout align-center="" fill-height="" justify-start="">

                                            <v-flex sm6 md6>
                                                <v-btn icon>
                                                    <v-icon data-test="sf-satir-duzenle" @click="satirduzenle(item)" color="teal">edit</v-icon>
                                                </v-btn>
                                            </v-flex>
                                            <v-flex sm6 md6>
                                                <v-btn data-test="sf-satir-sil" @click="satirsilsor(item)" icon>
                                                    <v-icon color="red">delete</v-icon>
                                                </v-btn>
                                            </v-flex>
                                        </v-layout>
                                    </v-card>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                        <v-divider :key="item.id"></v-divider>
                    </template>

                </v-card>
            </v-flex>
        </v-layout>
    </v-flex>


                                        <v-flex v-show="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm" xs12 sm12 md12>
                                            <v-card class="grey--text">
                                                <template v-for="(item, sira) in satiritems">
                                                    <v-layout pa-1 v-bind:key="sira" row wrap>
                                                        <v-layout row wrap>
                                                            <v-flex xs6 sm6 md6>
                                                                <v-layout align-center="" justify-start="" fill-height="">
                                                                    <span class="subheading font-weight-">
                                                                        {{ sira + 1 }}. {{$t('Description')}}:
                                                                    </span>
                                                                </v-layout>
                                                            </v-flex>
                                                            <v-flex xs6 sm6 md6>
                                                                <v-layout align-center="" justify-end="" fill-height="">
                                                                    <span class="subheading font-weight-thin">
                                                                        {{item.Aciklama}}
                                                                    </span>
                                                                </v-layout>
                                                            </v-flex>

                                                            <v-flex xs6 sm6 md6>
                                                                <v-layout align-center="" justify-start="" fill-height="">
                                                                    <span class="subheading font-weight-">
                                                                        {{$t('Discount')}}
                                                                    </span>
                                                                </v-layout>
                                                            </v-flex>
                                                            <v-flex xs6 sm6 md6>
                                                                <v-layout align-center="" justify-end="" fill-height="">
                                                                    <span class="subheading font-weight-thin">
                                                                        {{item.IskontoTutar | moneyformat}}{{getparabirimi()}}
                                                                    </span>
                                                                </v-layout>
                                                            </v-flex>

                                                            <v-flex xs6 sm6 md6>
                                                                <v-layout align-center="" justify-start="" fill-height="">
                                                                    <span class="subheading font-weight-">
                                                                         {{ $t('Withholding-VAT') }} :
                                                                    </span>
                                                                </v-layout>
                                                            </v-flex>
                                                            <v-flex xs6 sm6 md6>
                                                                <v-layout align-center="" justify-end="" fill-height="">
                                                                    <span class="subheading font-weight-thin">
                                                                        {{item.TevkifatDetayTutar | moneyformat}}{{getparabirimi()}}
                                                                    </span>
                                                                </v-layout>
                                                            </v-flex>

                                                            <v-flex xs6 sm6 md6>
                                                                <v-layout align-center="" justify-start="" fill-height="">
                                                                    <span class="subheading font-weight-">
                                                                        {{ $t('VAT-Rate') }}:
                                                                    </span>
                                                                </v-layout>
                                                            </v-flex>
                                                            <v-flex xs6 sm6 md6>
                                                                <v-layout align-center="" justify-end="" fill-height="">
                                                                    <span class="subheading font-weight-thin">
                                                                        {{item.KdvYuzde }}
                                                                    </span>
                                                                </v-layout>
                                                            </v-flex>

                                                            <v-flex xs6 sm6 md6>
                                                                <v-layout align-center="" justify-start="" fill-height="">
                                                                    <span class="subheading font-weight-">
                                                                         {{ $t('VAT-Amount') }} :
                                                                    </span>
                                                                </v-layout>
                                                            </v-flex>
                                                            <v-flex xs6 sm6 md6>
                                                                <v-layout align-center="" justify-end="" fill-height="">
                                                                    <span class="subheading font-weight-thin">
                                                                        {{item.KdvTutar | moneyformat}}{{getparabirimi()}}
                                                                    </span>
                                                                </v-layout>
                                                            </v-flex>
                                                            <v-flex xs6 sm6 md6>
                                                                <v-layout align-center="" justify-start="" fill-height="">
                                                                    <span class="subheading font-weight-">
                                                                       {{ $t('Amount')}} :
                                                                    </span>
                                                                </v-layout>
                                                            </v-flex>
                                                            <v-flex xs6 sm6 md6>
                                                                <v-layout align-center="" justify-end="" fill-height="">
                                                                    <span class="subheading font-weight-thin">
                                                                        {{item.Tutar | moneyformat}}{{getparabirimi()}}
                                                                    </span>
                                                                </v-layout>
                                                            </v-flex>
                                                            <v-flex xs12 sm12 md12>
                                                                <v-divider light></v-divider>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-layout>
                                                </template>
                                            </v-card>
                                        </v-flex>

                                    </v-layout>

                                </v-card-actions>
                            </v-card>
                        </v-card>
                    </v-flex>
                </v-container>

    <!-- Secili kalemlere tek seferde muhasebe kodu (bkz. topluMuhasebeUygula).
         API'ye istek atmaz: kod yalnizca formdaki kalemlere yazilir; kalici
         olmasi icin fatura Kaydet / Guncelle ile kaydedilir. -->
    <v-dialog v-model="topluMuhasebeDialog" persistent max-width="500px">
        <v-card>
            <v-card-title class="headline">{{ $t('Assign-Accounting-Code') }}</v-card-title>
            <v-card-text>
                <div class="grey--text mb-2">{{ $t('Selected-Lines') }}: {{ seciliKalemler.length }}</div>
                <muhasebekoducomp data-test="sf-toplu-muhasebe-kodu" :etiket="$t('Accounting-Code')" v-model="topluMuhasebeKodu"></muhasebekoducomp>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn data-test="sf-toplu-muhasebe-iptal" color="blue darken-1" flat @click="topluMuhasebeDialog = false">{{ $t("cancel_button") }}</v-btn>
                <v-btn data-test="sf-toplu-muhasebe-uygula" color="blue darken-1" flat :disabled="!topluMuhasebeKoduGecerli" @click="topluMuhasebeUygula()">{{ $t('Apply') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="satirdialog" scrollable="" persistent="" max-width="800px">
        <v-card color="grey lighten-5">
            <v-card-title> {{ $t('Line-Entry') }} </v-card-title>
            <v-divider></v-divider>
            <v-card-text>

                <v-layout row wrap="">

                    <v-flex pa-1 xs12 sm6 md6>
                        <v-card class="white--text">
                            <v-card flat="">
                                <v-card-actions>

                                    <v-layout justify-space-between column>

                                        <muhasebekoducomp data-test="sf-satir-muhasebe-kodu" :etiket="$t('Accounting-Code')" v-model="SerbestFaturaDetay.MuhasebeKodu">
                                        </muhasebekoducomp>

                                        <v-text-field data-test="sf-satir-aciklama" hide-details="" v-model="SerbestFaturaDetay.Aciklama" maxlength="499" aria-multiline="" :label="$t('Description')"></v-text-field>

                                        <v-text-field v-model="SerbestFaturaDetay.LineNote" hide-details="" aria-multiline="" :label="$t('Line-Note')"></v-text-field>
                                        <referansmerkezicomp :coper="false" v-model="SerbestFaturaDetay.Referans.Kod"></referansmerkezicomp>

                                        <masrafmerkezicomp v-model="SerbestFaturaDetay.Masraf.Code"></masrafmerkezicomp>

                                        <v-text-field data-test="sf-satir-miktar" type="number" hide-details="" v-model="SerbestFaturaDetay.Miktar" :label="$t('Unit-Quantity')">
                                        </v-text-field>

                                        <v-select v-model="SerbestFaturaDetay.Birim" hide-details="" :label="$t('Unit')" item-text="text" item-value="value" :items="birim" persistent-hint></v-select>

                                        <parainput data-test="sf-satir-birim-fiyat" :simge="getdefaultparabirimi(fatura.Doviz.DovizKod)" v-model="SerbestFaturaDetay.BirimFiyat" :hane="4" :etiket="$t('Unit-Price')" @input="dovizlitutarhesapla()" :autocomplete="autocomplete">
                                        </parainput>

                                        <parainput :simge="getparabirimi()" v-model="SerbestFaturaDetay.Tutar" :etiket="this.$t('Amount')" @input="YuzdeKontrol()" @odakkaybi="satirTutarOdakKaybi" :autocomplete="autocomplete">
                                        </parainput>

                                        <parainput @odakkaybi="satirDovizOdakKaybi" :simge="getdefaultparabirimi(fatura.Doviz.DovizKod)" v-model="SerbestFaturaDetay.DovizTutar" :etiket="$t('Currency-Amount')" :autocomplete="autocomplete">
                                        </parainput>
                                    </v-layout>

                                </v-card-actions>
                            </v-card>
                        </v-card>
                    </v-flex>

                    <v-flex pa-1 xs12 sm6 md6>
                        <v-card class="white--text">
                            <v-card flat="">
                                <v-card-actions>
                                    <v-layout justify-space-between column>
                                        <v-select data-test="sf-satir-kdv-tip" hide-details="" :items="kdvtipi" :label="$t('VAT-Type')" v-model="SerbestFaturaDetay.KdvTip" item-text="text" clearable item-value="value"></v-select>
                                        <v-layout>
                                            <yuzdeinput data-test="sf-satir-iskonto-yuzde" :etiket="$t('Discount-Percentage')" v-model="SerbestFaturaDetay.IskontoYuzde"></yuzdeinput>

                                            <parainput :simge="getparabirimi()" v-model="SerbestFaturaDetay.IskontoTutar" :etiket="$t('Discount-Amount')" :autocomplete="autocomplete"></parainput>

                                        </v-layout>
                                        <v-layout>
                                            <yuzdeinput data-test="sf-satir-kdv-yuzde" v-model="SerbestFaturaDetay.KdvYuzde" :etiket="$t('VAT-Percentage')"></yuzdeinput>
                                            <parainput :simge="getparabirimi()" v-model="SerbestFaturaDetay.KdvTutar" :etiket="$t('VAT-Amount')" :aktif="kdvShow" :autocomplete="autocomplete"></parainput>
                                        </v-layout>

                                        <muhasebekoducomp data-test="sf-satir-kdv-muh-kodu" :etiket="$t('VAT-Accounting-Code')" v-model="SerbestFaturaDetay.KdvMuhKodu">
                                        </muhasebekoducomp>

                                        <muhasebekoducomp data-test="sf-satir-isk-muh-kodu" :etiket="$t('Discount-Accounting-Code')" v-model="SerbestFaturaDetay.IskMuhKodu">
                                        </muhasebekoducomp>

                                        <geneltiplist data-test="sf-satir-kdv-kodu" v-model="SerbestFaturaDetay.KdvKodu" :etiket="$t('VAT-Code')" :listetip="'303'">
                                        </geneltiplist>

                                        <geneltiplist data-test="sf-satir-istisna-kodu" v-model="SerbestFaturaDetay.IstisnaKodu" :etiket="$t('Exception-Code')" :listetip="'304'">
                                        </geneltiplist>

                                        <v-select data-test="sf-satir-tevkifat-oran" :items="Tevkifat" v-if="detaytevkifat && PB=='TRY'" hide-details="" item-text="text" item-value="value" clearable v-model="SerbestFaturaDetay.TevkifatDetayOran" @change="Tevkifatkdvhesapla()" :label="$t('Deduction-Rate')"></v-select>

                                        <parainput :simge="getparabirimi()" :aktif="'false'" v-if="detaytevkifat && PB=='TRY'" v-model="SerbestFaturaDetay.TevkifatDetayTutar" :etiket="'Tev. KDV Tutar'" :autocomplete="autocomplete"></parainput>

                                        <geneltiplist data-test="sf-satir-tevkifat-kodu" v-if="PB=='TRY'" v-model="SerbestFaturaDetay.TevkifatKodu" :etiket="$t('Withholding-Code')" :listetip="'302'">
                                        </geneltiplist>

                                    </v-layout>
                                </v-card-actions>
                            </v-card>
                        </v-card>
                    </v-flex>

                    <v-flex xs12 v-if="ihracat" pa-1 sm12 md12>

                        <v-toolbar flat="" size="120px" dark color="#9E9E9E">
                            <v-toolbar-title> {{ $t('Importation-Details') }} </v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </v-flex>

                    <v-flex pa-1 v-if="ihracat" xs12 sm6 md6>
                        <v-card class="white--text">
                            <v-card flat="">
                                <v-card-actions>
                                    <v-layout justify-space-between column>

                                        <v-text-field v-model="SerbestFaturaDetay.TeslimBilgileri.SokakAdi" hide-details="" :label="$t('Delivery-Street')"></v-text-field>

                                        <v-text-field hide-details="" v-model="SerbestFaturaDetay.TeslimBilgileri.BinaAdi" :label="$t('Delivery-Building')"></v-text-field>

                                        <v-text-field hide-details="" v-model="SerbestFaturaDetay.TeslimBilgileri.BinaNo" :label="$t('Delivery-Building-No')"></v-text-field>

                                        <v-text-field hide-details="" v-model="SerbestFaturaDetay.TeslimBilgileri.TeslimSehir" :label="$t('Delivery-Province')"></v-text-field>

                                        <v-text-field hide-details="" v-model="SerbestFaturaDetay.TeslimBilgileri.TeslimPostaKodu" :label="$t('Delivery-Postal-Code')"></v-text-field>

                                        <v-text-field hide-details="" v-model="SerbestFaturaDetay.TeslimBilgileri.TeslimUlke" :label="$t('Delivery-Country')"></v-text-field>

                                        <v-select :label="$t('Delivery-Payment')" clearable="" v-model="SerbestFaturaDetay.TeslimBilgileri.TeslimOdeme" :items="teslimodeme"></v-select>

                                    </v-layout>
                                </v-card-actions>
                            </v-card>
                        </v-card>
                    </v-flex>

                    <v-flex pa-1 v-if="ihracat" xs12 sm6 md6>
                        <v-card class="white--text">
                            <v-card flat="">
                                <v-card-actions>
                                    <v-layout justify-space-between column>

                                        <v-text-field v-model="SerbestFaturaDetay.TeslimBilgileri.TeslimSarti" hide-details="" :label="$t('Delivery-Condition')"></v-text-field>

                                        <v-text-field hide-details="" :error-messages="errors.collect('gtip')" v-validate="'min:4'" data-vv-name="gtip" v-model="SerbestFaturaDetay.TeslimBilgileri.GTIPNo" :label="$t('GTIP-No')">
                                        </v-text-field>

                                        <v-select :items="transferkodu" hide-details="" v-model="SerbestFaturaDetay.TeslimBilgileri.TransferKodu" :label="$t('Transfer-Code')" item-text="text" item-value="value" max-height="400"></v-select>

                                        <v-text-field hide-details="" v-model="SerbestFaturaDetay.TeslimBilgileri.KabinNo" :label="$t('Cabin-No')"></v-text-field>

                                        <v-text-field type="number" v-model="SerbestFaturaDetay.TeslimBilgileri.KabinAdedi" hide-details="" :label="$t('Number-of-Cabins')"></v-text-field>

                                        <v-text-field hide-details="" v-model="SerbestFaturaDetay.TeslimBilgileri.KabinCinsi" :label="$t('Cabin-Type')"></v-text-field>

                                    </v-layout>
                                </v-card-actions>
                            </v-card>
                        </v-card>
                    </v-flex>
                </v-layout>

            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="satirDialogIptal()">{{$t("cancel_button")}}</v-btn>

                <kaydetbutonu data-test="sf-satir-kaydet" v-if="satirkaydetbuton" :disabled="calculateDisabled" color="blue darken-1" :action="satirkaydet">{{$t('Add-Line')}}</kaydetbutonu>

                <v-btn data-test="sf-satir-guncelle" v-if="satirguncellebuton" :disabled="calculateDisabled || satirGuncelleniyor" :loading="satirGuncelleniyor" color="blue darken-1" flat @click.native="satirguncellekaydet()">{{ $t('Update') }}
                </v-btn>

            </v-card-actions>
        </v-card>
    </v-dialog>


    <!-- DIP TOPLAMLAR. Toplamlari bu bilesen hesapliyor (toplamlariYenile ->
         fatura.Tutarlar); gosterim de burada ki bileseni kullanan her sayfada
         (serbestfatura, faturakopya) ayni olsun. Onceden serbestfatura'nin kendi
         sablonundaydi; faturakopya ortak bilesene baglanirken "toplamlar
         bilesende" sanilip silinmisti ve o ekranda dip toplam hic gorunmuyordu. -->
    <v-container fluid>
        <v-layout>
            <v-flex xs12 sm12 md12>
                <v-layout justify-end="" row>
                    <v-flex xs12 sm12 md4 class="dip-toplam-sutun">
                        <v-card flat class="white--text">
                            <v-layout>
                                <v-flex xs2 sm2 md2>
                                    <v-layout align-center="" justify-center="" fill-height="">
                                        <v-icon color="info" large="">queue</v-icon>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs10 sm10 md10>

                                    <v-card-title primary-title="">
                                        <!-- Genel Toplam ile ayni duzen: TL satiri, altinda "... Doviz" satiri; tutarlar hizali -->
                                        <table class="subheading grey--text" style="border-collapse:collapse;font-variant-numeric:tabular-nums;">
                                            <tr>
                                                <td style="padding-right:12px;white-space:nowrap;">{{ $t('Amount') }}</td>
                                                <td style="padding-right:6px;">:</td>
                                                <td style="text-align:right;white-space:nowrap;">{{SerbestFatura.Tutarlar.ToplamTutar | moneyformat}}{{getparabirimi()}}</td>
                                            </tr>
                                            <tr v-if="dovizToplam">
                                                <td style="padding-right:12px;white-space:nowrap;">{{ $t('Amount') }} {{ $t('Currency') }}</td>
                                                <td style="padding-right:6px;">:</td>
                                                <td style="text-align:right;white-space:nowrap;">{{dovizToplam.ToplamTutar | moneyformat}}{{dovizSimgesi}}</td>
                                            </tr>
                                            <tr>
                                                <td style="padding-right:12px;white-space:nowrap;">{{ $t('DISCOUNT') }}</td>
                                                <td style="padding-right:6px;">:</td>
                                                <td style="text-align:right;white-space:nowrap;">{{SerbestFatura.Tutarlar.Iskonto | moneyformat}}{{getparabirimi()}}</td>
                                            </tr>
                                            <tr v-if="dovizToplam">
                                                <td style="padding-right:12px;white-space:nowrap;">{{ $t('DISCOUNT') }} {{ $t('Currency') }}</td>
                                                <td style="padding-right:6px;">:</td>
                                                <td style="text-align:right;white-space:nowrap;">{{dovizToplam.Iskonto | moneyformat}}{{dovizSimgesi}}</td>
                                            </tr>
                                            <tr v-if="PB=='TRY'">
                                                <td style="padding-right:12px;white-space:nowrap;">{{ $t('Withholding-Amount') }}</td>
                                                <td style="padding-right:6px;">:</td>
                                                <td style="text-align:right;white-space:nowrap;">{{SerbestFatura.Tutarlar.TevkifatKdv | moneyformat}}{{getparabirimi()}}</td>
                                            </tr>
                                            <tr v-if="PB=='TRY' && dovizToplam">
                                                <td style="padding-right:12px;white-space:nowrap;">{{ $t('Withholding-Amount') }} {{ $t('Currency') }}</td>
                                                <td style="padding-right:6px;">:</td>
                                                <td style="text-align:right;white-space:nowrap;">{{dovizToplam.TevkifatKdv | moneyformat}}{{dovizSimgesi}}</td>
                                            </tr>
                                        </table>
                                    </v-card-title>
                                </v-flex>
                            </v-layout>
                            <v-divider light></v-divider>
                            <v-card-actions class="pa-3">
                                <!-- TL ve doviz toplamlari alt alta; tutarlar ve KDV'ler hizali olsun diye tablo.
                                     Genislik kurallari (kart en az genisligi, dar ekranda KDV'nin alta inmesi) style blogunda. -->
                                <table class="subheading grey--text genel-toplam" style="border-collapse:collapse;font-variant-numeric:tabular-nums;">
                                    <tr>
                                        <td style="padding-right:12px;white-space:nowrap;">{{ $t('Grand-Total') }}</td>
                                        <td style="padding-right:6px;">:</td>
                                        <td style="text-align:right;white-space:nowrap;">{{SerbestFatura.Tutarlar.FaturaToplam | moneyformat}}{{getparabirimi()}}
                                            <div class="kdv-alt">({{SerbestFatura.Tutarlar.Kdv | moneyformat}}{{getparabirimi()}} {{ $t('VAT') }})</div></td>
                                        <td class="kdv-sutun" style="text-align:right;white-space:nowrap;padding-left:6px;">({{SerbestFatura.Tutarlar.Kdv | moneyformat}}{{getparabirimi()}} {{ $t('VAT') }})</td>
                                    </tr>
                                    <tr v-if="dovizToplam">
                                        <td style="padding-right:12px;white-space:nowrap;">{{ $t('Grand-Total') }} {{ $t('Currency') }}</td>
                                        <td style="padding-right:6px;">:</td>
                                        <td style="text-align:right;white-space:nowrap;">{{dovizToplam.FaturaToplam | moneyformat}}{{dovizSimgesi}}
                                            <div class="kdv-alt">({{dovizToplam.Kdv | moneyformat}}{{dovizSimgesi}} {{ $t('VAT') }})</div></td>
                                        <td class="kdv-sutun" style="text-align:right;white-space:nowrap;padding-left:6px;">({{dovizToplam.Kdv | moneyformat}}{{dovizSimgesi}} {{ $t('VAT') }})</td>
                                    </tr>
                                </table>
                                <v-spacer></v-spacer>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-container>

  </div>
</template>

<script>
/**
 * FATURA KALEMLERI
 *
 * fatura/serbestfatura.vue bu bileseni kullanir (faturakopya adresi onun kopya
 * modu). Bilesen, iki ayri ekran varken kuruldu: sablonlari %95, script'leri
 * %86 ayniydi; faturakopya eski bir
 * serbestfatura kopyasi oldugu icin hesaplar zamanla ayrismisti (KDV 4
 * hane / 2 hane gibi) ve AYNI fatura icin FARKLI tutar uretiyorlardi.
 *
 * Buradaki kod SERBESTFATURA'nin surumudur -- kullanici karari.
 *
 * ---------------------------------------------------------------------
 * NEDEN `fatura` PROP'U VAR
 *
 * Bilesen satir listesini (v-model) yonetiyor ama fatura TOPLAMLARINI da
 * yaziyor; baslikta gorunen degerler bunlar.
 *
 * Toplamlar SATIRLARDAN SIFIRDAN hesaplaniyor (toplamlariYenile ->
 * faturaHesap.faturaToplamlari). Onceden bu uc metot toplamlari elle ve
 * ARTIMLI duzeltiyordu:
 *
 *     this.fatura.Tutarlar.ToplamTutar -= this.yedeksatirkayit.Tutar
 *     ...
 *     this.fatura.Tutarlar.ToplamTutar += satiryeni.Tutar
 *
 * Uc metotta 28 boyle satir vardi. Bir satir iki kez dusulur ya da hic
 * dusulmezse baslik satirlarla tutmuyordu ve bunu fark etmenin yolu
 * yoktu. Sifirdan hesaplamak o hata sinifini tumden kaldiriyor ve
 * "kalem toplami her zaman baslikla ayni" garantisini veriyor.
 *
 * Prop'un ic nesnesini degistirmek Vue'da alisildik degildir; toplamlarin
 * sahibi bu bilesen oldugu icin bilincli olarak yapiliyor.
 * ---------------------------------------------------------------------
 *
 * Arayuz:
 *   :fatura      fatura nesnesi (Kur, Dovizli, Doviz, Tutarlar)
 *   v-model      kalem dizisi
 *   ...acilir liste verileri
 *   @hata        kullaniciya gosterilecek mesaj (sayfanin snackbar'ina)
 */
import tool from '@/components/app/coper/tools.js'
import helpers from "@/components/app/customcomp/helpers.js";
import hesap from "./faturaHesap.js";
import parainput from "@/components/app/customcomp/parainput.vue";
import yuzdeinput from "@/components/app/customcomp/yuzdeinput.vue";
import muhasebekoducomp from "@/components/app/customcomp/muhasebekoducomp.vue";
import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue";
import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue";
import geneltiplist from "@/components/app/customcomp/geneltiplist.vue";
import caricomp from "@/components/app/customcomp/caricomp.vue";
import dovizinput from "@/components/app/customcomp/dovizinput.vue";
import tarihcomp from "@/components/app/customcomp/tarihim";
import reportbrosablon from "@/components/app/coper/comp/reportbrosablon.vue";
import kaydetbutonu from "@/components/app/customcomp/kaydetbutonu.vue";

export default {
  name: "faturakalemleri",


  components: {
    parainput, yuzdeinput,
    muhasebekoducomp, referansmerkezicomp, masrafmerkezicomp, geneltiplist,
    caricomp, dovizinput, tarihcomp, reportbrosablon, kaydetbutonu
  },

  props: {
    /** Fatura nesnesi. Kur/Dovizli/Doviz okunur, Tutarlar GUNCELLENIR. */
    fatura: { type: Object, required: true },

    /** Kalem dizisi (v-model). */
    value: { type: Array, default: function () { return []; } },

    /** false ise satir ekle/duzelt/sil gizlenir. */
    duzenlenebilir: { type: Boolean, default: true },

    /**
     * Acilir liste verileri. Sayfa zaten API'den cekiyor; bilesen ayrica
     * istek atmasin diye prop olarak aliniyor.
     */

    /* --- Asama 1: sayfadan gecici olarak prop ile geliyor.
       Asama 2'de bu listelerin ve bayraklarin cogu bilesenin kendi
       durumu olacak (API cagrilariyla birlikte). --- */
    guncellebuton: { type: Boolean, default: false },
    yazdirbtngoster: { type: Boolean, default: false },
    sayfayetki: { type: Object, default: function () { return {}; } },

    /* --- Sayfanin durumuyla acilan diyaloglar: acma/kapama ve istekler sayfada
       (loadingdialog, dialogsor, faturasil), gorunum bu bilesende. --- */
    /** Yukleme penceresi acik mi (sayfanin loadingdialog'u). */
    yukleniyor: { type: Boolean, default: false },
    /** Fatura silme onayi acik mi; `.sync` ile yazilir (sayfanin dialogsor'u). */
    faturasilonayi: { type: Boolean, default: false },
    /** Fatura silme islemi (sayfanin faturasil'i). Promise dondurur; OK butonu cevabi bekler. */
    faturasilislemi: { type: Function, default: function () {} },
  },

  data() {
    return {
      satirdialog: false,
      /* Fatura yuklenirken gelen Kur kullanici girisi degildir; kilit
         o an kapali olur (bkz. `fatura` ve `SerbestFatura.Kur`
         izleyicileri). */
      kurYenidenHesapla: true,
      satirkaydetbuton: true,
      satirGuncelleniyor: false,
      satirSiliniyor: false,
      satirguncellebuton: false,
      calculateDisabled: false,
      secilensatirno: -1,
      /* Toplu muhasebe kodu. Secili kalemler NESNE KIMLIGIYLE tutulur:
         satirlarda id yok, ayni icerikli iki satir olabilir ve index
         silme / ekleme ile kayar. */
      secilenKalemler: [],
      topluMuhasebeDialog: false,
      topluMuhasebeKodu: '',
      silinecekkayit: null,
      guncelleMiktarKontrol: 0,
      yedeksatirkayit: { Tutar: 0, Kdv: 0, Tevkifat: 0, iskonto: 0 },

      // Asagidakiler tasinan metotlarin/sablonun kullandigi, sayfada
      // tanimli olan durum alanlari. Kaynaktaki varsayilanlariyla birebir.
      dialogsor: false,        // satir silme onay dialogu
      satirsilbtn: false,
      degisenkayit: null,      // duzenlenmek uzere secilen satir
      secilenkdvtipi: null,
      kdvShow: true,
      autocomplete: "autocomplete",

      /** Dialogda duzenlenen kalem. Dizideki satirlarla KARISTIRILMAMALI. */
      /* --- Asama 2a: sayfadan tasinan arama listeleri ve bayraklar --- */
      kdvtipi: [{
              text: 'D',
              value: 'D'
          },
          {
              text: 'H',
              value: 'H'
          }
      ],
      birim: [{
              text: 'adet',
              value: 'adet'
          },
          {
              text: 'kilo',
              value: 'kilo'
          }, {
              text: this.$t('gram'),
              value: 'gram'
          }, {
              text: this.$t('meter'),
              value: 'metre'
          },
          {
              text: 'litre',
              value: 'litre'
          },
          {
              text: 'm2',
              value: 'm2'
          },
          {
              text: 'dm2',
              value: 'dm2'
          },
          {
              text: 'm3',
              value: 'm3'
          },
      ],
      Tevkifat: [{
              text: '0/10',
              value: 0
          },
          {
              text: '1/10',
              value: 0.1
          },
          {
              text: '2/10',
              value: 0.2
          },
          {
              text: '3/10',
              value: 0.3
          },
          {
              text: '4/10',
              value: 0.4
          },
          {
              text: '5/10',
              value: 0.5
          },
          {
              text: '6/10',
              value: 0.6
          },
          {
              text: '7/10',
              value: 0.7
          },
          {
              text: '8/10',
              value: 0.8
          },
          {
              text: '9/10',
              value: 0.9
          },
          {
              text: '10/10',
              value: 1
          }
      ],
      detaytevkifat: true,
      transferkodu: [{
              text: this.$t('Seaways'),
              value: 1
          },
          {
              text: this.$t('Railway'),
              value: 2
          },
          {
              text: this.$t('Highway'),
              value: 3
          },
          {
              text: this.$t('Airline'),
              value: 4
          },
          {
              text: this.$t('Post'),
              value: 5
          },
          {
              text: this.$t('Multiple-Vehicles'),
              value: 6
          },
          {
              text: this.$t('Fixed-Transportation-Complexes'),
              value: 7
          },
          {
              text: this.$t('Territorial-Water-Transportation'),
              value: 8
          }
      ],
      teslimodeme: [{
              text: 'Instrument not defined',
              value: 1
          },
          {
              text: 'Automated clearing house credit',
              value: 2
          },
          {
              text: 'Automated clearing house debit',
              value: 3
          },
          {
              text: 'ACH demand debit reversal',
              value: 4
          },
          {
              text: 'ACH demand credit reversal',
              value: 5
          },
          {
              text: 'ACH demand credit',
              value: 6
          },
          {
              text: 'ACH demand debit',
              value: 7
          },
          {
              text: 'Hold',
              value: 8
          },
          {
              text: 'National or regional clearing',
              value: 9
          },
          {
              text: 'In cash',
              value: 10
          },
          {
              text: 'ACH savings credit reversal',
              value: 11
          },
          {
              text: 'ACH savings debit reversal',
              value: 12
          },
          {
              text: 'ACH savings credit',
              value: 13
          },
          {
              text: 'ACH savings debit',
              value: 14
          },
          {
              text: 'Bookentry credit',
              value: 15
          },
          {
              text: 'Bookentry debit',
              value: 16
          },
          {
              text: 'ACH demand cash concentration/disbursement (CCD) credit',
              value: 17
          },
          {
              text: 'ACH demand cash concentration/disbursement (CCD) debit',
              value: 18
          },
          {
              text: 'ACH demand corporate trade payment (CTP) credit',
              value: 19
          },
          {
              text: 'Cheque',
              value: 20
          },
          {
              text: 'Bankers draft',
              value: 21
          },
          {
              text: 'Certified bankers draft',
              value: 22
          },
          {
              text: 'Bank cheque (issued by a banking or similar establishment)',
              value: 23
          },
          {
              text: 'Certified cheque',
              value: 25
          },
          {
              text: 'Local cheque',
              value: 26
          },
          {
              text: 'ACH demand corporate trade payment (CTP) debit',
              value: 27
          },
          {
              text: 'ACH demand corporate trade exchange (CTX) credit',
              value: 28
          },
          {
              text: 'ACH demand corporate trade exchange (CTX) debit',
              value: 29
          },
          {
              text: 'Credit transfer',
              value: 30
          },
          {
              text: 'Debit transfer',
              value: 31
          },
          {
              text: 'ACH demand cash concentration/disbursement plus (CCD+)',
              value: 32
          },
          {
              text: 'ACH demand cash concentration/disbursement plus (CCD+)',
              value: 33
          },
          {
              text: 'ACH prearranged payment and deposit (PPD)',
              value: 34
          },
          {
              text: ' ACH savings cash concentration/disbursement (CCD) credit',
              value: 35
          },
          {
              text: 'ACH savings cash concentration/disbursement (CCD) debit',
              value: 36
          },
          {
              text: 'ACH savings corporate trade payment (CTP) credit',
              value: 37
          },
          {
              text: 'ACH savings corporate trade payment (CTP) debit',
              value: 38
          },
          {
              text: 'ACH savings corporate trade exchange (CTX) credit',
              value: 39
          },
          {
              text: 'ACH savings corporate trade exchange (CTX) debit',
              value: 40
          },
          {
              text: 'ACH savings cash concentration/disbursement plus (CCD+)',
              value: 41
          },
          {
              text: 'Payment to bank account',
              value: 42
          },
          {
              text: 'ACH savings cash concentration/disbursement plus (CCD+)',
              value: 43
          },
          {
              text: 'Accepted bill of exchange',
              value: 44
          },
          {
              text: 'Referenced home-banking credit transfer',
              value: 45
          },
          {
              text: 'Interbank debit transfer',
              value: 46
          },
          {
              text: 'Home-banking debit transfer',
              value: 47
          },
          {
              text: 'Bank card',
              value: 48
          },
          {
              text: 'Direct debit',
              value: 49
          },
          {
              text: 'Payment by postgiro',
              value: 50
          },
          {
              text: 'Promissory note',
              value: 60
          },
          {
              text: '61    Promissory note signed by the debtor',
              value: 61
          },
          {
              text: 'Promissory note signed by the debtor and endorsed by a bank',
              value: 62
          },
          {
              text: 'Promissory note signed by the debtor and endorsed by a',
              value: 63
          },
          {
              text: ' Promissory note signed by a bank',
              value: 64
          },
          {
              text: 'Promissory note signed by a bank and endorsed by another',
              value: 65
          },
          {
              text: 'Promissory note signed by a third party',
              value: 66
          },
          {
              text: 'Promissory note signed by a third party and endorsed by a',
              value: 67
          },
          {
              text: 'Bill drawn by the creditor on the debtor',
              value: 70
          },
          {
              text: 'Bill drawn by the creditor on a bank',
              value: 74
          },
          {
              text: 'Bill drawn by the creditor, endorsed by another bank',
              value: 75
          },
          {
              text: 'Bill drawn by the creditor on a bank and endorsed by a',
              value: 76
          },
          {
              text: 'Bill drawn by the creditor on a third party',
              value: 77
          },
          {
              text: 'Bill drawn by creditor on third party, accepted and',
              value: 78
          },
          {
              text: 'Not transferable banker s draft',
              value: 91
          },
          {
              text: 'Not transferable local cheque',
              value: 92
          },
          {
              text: 'Reference giro',
              value: 93
          },
          {
              text: 'Urgent giro',
              value: 94
          },
          {
              text: 'Free format giro',
              value: 95
          },
          {
              text: 'Requested method for payment was not used',
              value: 96
          },
          {
              text: 'Clearing between partners',
              value: 97
          }

      ],
      dizaynsec: [],
      dizaynDovizli: null,   // son istenen dizayn listesinin doviz durumu (bkz. dizayngetir)
      dizaynIstekNo: 0,      // gec donen eski yanit listeyi ezmesin diye son istegin numarasi
      doviztipi: [],
      efaturatipi: [{
              text: this.$t('Commercial'),
              value: '0'
          },
          {
              text: this.$t('Basic'),
              value: '1'
          },
          {
              text: this.$t('Export'),
              value: '2'
          },{
              text: this.$t('Public'),
              value: '3'
          }
      ],
      EvrakTipi1: [],
      faturatipi: [{
              text: this.$t('Sales-Invoice'),
              value: 0
          },
          {
              text: this.$t('Return-Invoice'),
              value: 1
          }
      ],
      xsltitems: [],
      reportbroview: false,
      dizayngoster: true,
      loading: false,

      /* --- Asama 2b/2c: cari + e-arsiv durumu --- */
      ihracat: false,
      gibseri: [],
      gibserigoster: true,
      seridisable: false,
      efaturatipigecici: 0,
      yuklenenCariKod: null,   // yuklenen faturanin cari kodu (bkz. cariBilgisiGeldi)
      gonderimlabel: null,
      internetsatislabel: null,
      odemeseklilabel: null,
      odemesekliaciklamalabel: null,
      odemearacilabel: null,
      odemetarihilabel: null,
      webadresilabel: null,
      gonderimsekli: [{
              text: this.$t('Paper'),
              value: 0
          },
          {
              text: this.$t('Electronic'),
              value: 1
          }
      ],
      odemesekli: [{
              text: this.$t('Normal-Sales'),
              value: 0
          },
          {
              text: this.$t('Internet-Sales'),
              value: 1
          }
      ],
      odemesekli1: [{
              text: this.$t('Credit-Debit-Card'),
              value: '0'
          },
          {
              text: 'EFT-' + this.$t('Transfer-v3'),
              value: '1'
          },
          {
              text: this.$t('Cash-on-delivery'),
              value: '2'
          },
          {
              text: this.$t('Payment-Intermediary'),
              value: '3'
          },
          {
              text: this.$t('Other'),
              value: '4'
          }
      ],
      webadresleri: [],
      odemesekilleri: [],
      odemearaci: [],
      dialogearsiv: false,

      /** Para birimi: iki sayfa da ayni yerden okuyordu, bilesen kendisi alsin. */
      PB: (JSON.parse(window.localStorage.getItem('credentials')) || {}).ParaBirimi || 'TRY',

      SerbestFaturaDetay: {
                                MuhasebeKodu: '',
                                Aciklama: '',
                                LineNote: '',
                                Referans: {
                                    Kod: ''
                                },
                                Masraf: {
                                    Code: ''
                                },
                                Miktar: 0,
                                Birim: '',
                                BirimFiyat: 0,
                                Tutar: 0,
                                DovizTutar: 0,
                                IskontoYuzde: 0,
                                IskontoTutar: 0,
                                KdvTip: 'D',
                                KdvYuzde: 0,
                                KdvTutar: 0,
                                KdvMuhKodu: '',
                                IskMuhKodu: '',
                                KdvKodu: '',
                                IstisnaKodu: '',
                                TevkifatKodu: '',
                                Tip: '',
                                TevkifatDetayTutar: 0,
                                TevkifatDetayOran: 0,

                                TeslimBilgileri: {
                                    SokakAdi: '',
                                    BinaAdi: '',
                                    BinaNo: '',
                                    TeslimSehir: '',
                                    TeslimPostaKodu: '',
                                    TeslimUlke: '',
                                    TeslimSarti: '',
                                    GTIPNo: '',
                                    TransferKodu: '',
                                    KabinNo: '',
                                    KabinAdedi: '',
                                    KabinCinsi: '',
                                    TeslimOdeme: ''
                                }

                            }
    };
  },

  filters: {
    // serbestfatura.vue'da YEREL filtre olarak tanimliydi; global degil,
    // bu yuzden bilesene de tasindi.
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    }
  },

  computed: {
    /** Tasinan sablon `SerbestFatura` adini kullaniyor; yeniden
     *  adlandirma riski almamak icin prop'a takma ad. */
    SerbestFatura: function () { return this.fatura; },

    /** Tasinan mobil listede `satiritems` geciyor. */
    satiritems: function () { return this.value || []; },

    /** Secili ve hala listede duran kalemler. Silinen ya da guncellenip
     *  yerine yeni nesne konan satir kendiliginden secimden duser. */
    seciliKalemler: function () {
      var secili = this.secilenKalemler;
      return this.kalemler.filter(function (k) { return secili.indexOf(k) >= 0; });
    },
    tumuSecili: function () {
      return this.kalemler.length > 0 && this.seciliKalemler.length === this.kalemler.length;
    },
    kismenSecili: function () {
      return this.seciliKalemler.length > 0 && !this.tumuSecili;
    },
    topluMuhasebeKoduGecerli: function () {
      return typeof this.topluMuhasebeKodu === 'string' && this.topluMuhasebeKodu.trim() !== '';
    },

    /** Kalem dizisi. Degisiklikte `input` yayilir (v-model sozlesmesi). */
    kalemler: {
      get: function () { return this.value || []; },
      set: function (yeni) { this.$emit("input", yeni); }
    },

    /**
     * Dip toplamin doviz karsiligi. Yalnizca dovizli faturada ve gecerli bir
     * kur varsa doluyor; aksi halde null ve sablonda hic gosterilmiyor.
     * Satirlarin DOVIZ tutarlarinin toplami; TL toplamdan geri cevrilmez
     * (kural: faturaHesap.dovizSatirHesapla).
     */
    dovizToplam: function () {
      if (!this.SerbestFatura || this.SerbestFatura.Dovizli !== true) return null;
      return hesap.dovizToplamlari(this.satiritems, this.SerbestFatura.Kur);
    },

    /** Doviz satirlarinin yanindaki simge (USD -> $, EUR -> ...). */
    dovizSimgesi: function () {
      return helpers.getparabirimiDefault(
        this.SerbestFatura && this.SerbestFatura.Doviz
          ? this.SerbestFatura.Doviz.DovizKod : undefined);
    }
  },

  watch: {

    /**
     * Fatura nesnesi tumden degisti = sayfa yeni bir fatura yukledi
     * (faturaGetir: `this.SerbestFatura = response.body`).
     *
     * Yuklemede gelen Kur kullanici girisi DEGILDIR; o anda kalemleri
     * yeniden hesaplamak kayitli tutarlari bozar. Kilidi bir tik
     * kapatiyoruz; yukleme bittikten sonra kur degisimi yine islenir.
     */
    fatura: function (yeni, eski) {
      // Yuklenen faturanin kendi carisi: bu cari icin gelen ilk bilgide faturadaki
      // kayitli masraf merkezi korunur (bkz. cariBilgisiGeldi).
      this.yuklenenCariKod = yeni && yeni.Cari ? yeni.Cari.Kod : null;

      // Cari bilgisini caricomp getiriyor. Ayni cari koduyla YENI bir fatura nesnesi
      // geldiyse caricomp'un degeri degismedigi icin kendiliginden getirmez; faturaya
      // ozel alanlar (e-fatura bayraklari, GiB serisi, e-fatura bilgisi) yeni nesnede
      // kurulsun diye bir kez getirmesi istenir. Kod degistiyse caricomp zaten getiriyor.
      if (yeni && eski && yeni !== eski && yeni.Cari && eski.Cari && yeni.Cari.Kod
          && yeni.Cari.Kod === eski.Cari.Kod && this.$refs.cari) {
        this.$refs.cari.cariislemler();
      }


      // Dizayn listesi yuklenen faturanin doviz durumuyla istenir; ayni durum icin tekrar istenmez
      // (bkz. dizayngetir).
      this.dizayngetir();
      this.kurYenidenHesapla = false;
      this.$nextTick(function () {
        this.kurYenidenHesapla = true;

        // Baslik SATIRLARDAN yeniden hesaplanir.
        //
        // API geri okurken ToplamTutar'i farkli tanimliyor
        // (SerbestFaturaLoad.cs:131):
        //     ToplamTutar = tutar + iskonto + tevkdvtutar
        // yani iskonto ve tevkifati GERI EKLIYOR. Ekranda bu deger
        // satirlarin toplamini tutmuyordu: 30 kalemlik dovizli test
        // faturasinda satirlar 5.491.590,01 iken baslik 6.428.850,18
        // gorunuyordu.
        //
        // Kaydederken zaten sozlesme cevirisi yapiyoruz
        // (faturaHesap.apiIcinFatura); okurken de ekrani satirlarin
        // dilinde tutuyoruz. Boylece "baslik her zaman satirlarin
        // toplamidir" kurali kayit/geri okuma turunda da bozulmuyor.
        this.toplamlariYenile();
      }.bind(this));
    },

    /**
     * Kur degisince MEVCUT kalemler yeni kura gore duzeltilir.
     *
     * ONCEDEN DUZELMIYORDU: kur 48.4305 -> 60 yapilinca satir
     * `Tutar 300 / DovizTutar 6.1944` olarak kaliyordu; 6.1944 x 60 =
     * 371.66, yani baslikla satir ayni kurda olmayan iki tutar
     * tasiyordu.
     *
     * Yon (kullanici karari): DOVIZ TUTARI SABIT, TL yeniden hesaplanir.
     * Dovizli faturada fiyat doviz cinsinden belirlendigi icin kur
     * degisimi TL karsiligini degistirir, tersini degil.
     */
    'SerbestFatura.Kur': function (yeniKur) {
      if (!this.kurYenidenHesapla) { return; }
      if (this.SerbestFatura.Dovizli !== true) { return; }
      if (!(parseFloat(yeniKur) > 0)) { return; }
      this.kalemleriKuraGoreYenile(yeniKur);
    },

    /* --- Asama 2a: sayfadan tasinan izleyiciler --- */
    'SerbestFatura.Dovizli': function (val) {
        this.dizayngetir();
    },
    'SerbestFatura.Doviz.DovizKod': function (dovizkod) {
        if (dovizkod != null) {
            if (this.SerbestFatura.Kur == 0) {
                this.kurgetir('watch');
            }
        }
    },

    /* --- Asama 2b/2c: sayfadan tasinan izleyiciler --- */
    'SerbestFatura.EarsivBilgi.GonderimSekli': function (kod) {
        this.gonderimsekli.forEach(element => {
            if (kod == element.value) {

                this.gonderimlabel = element.text
            }
        });

    },
    'SerbestFatura.EarsivBilgi.InternetSatis': function (kod) {

        this.odemesekli.forEach(element => {
            if (kod == element.value) {
                this.internetsatislabel = element.text
            }
        });

    },
    'SerbestFatura.EarsivBilgi.WebAdresi': function (kod) {

        this.webadresleri.forEach(element => {
            if (kod == element.ID) {
                this.webadresilabel = element.Aciklama
            }
        });

    },
    'SerbestFatura.EarsivBilgi.OdemeSekli': function (kod) {

        this.odemesekli1.forEach(element => {
            if (kod == element.value) {
                this.odemeseklilabel = element.text
            }
        });

    },
    'SerbestFatura.EarsivBilgi.OdemeSekliAciklama': function (kod) {

        this.odemesekilleri.forEach(element => {
            if (kod == element.ID) {
                this.odemesekliaciklamalabel = element.Aciklama
            }
        });

    },
    'SerbestFatura.EarsivBilgi.OdemeAraci': function (kod) {

        this.odemearaci.forEach(element => {
            if (kod == element.ID) {
                this.odemearacilabel = element.Aciklama
            }
        });

    },
    'SerbestFatura.EarsivBilgi.OdemeTarihi': function (deger) {
        this.odemetarihilabel = this.tarihkontrol(deger)
    },

    'SerbestFaturaDetay.Miktar': function () {

      if(this.guncelleMiktarKontrol != 0 || this.satirkaydetbuton){
          // BirimFiyat alani sablonda zaten @input="dovizlitutarhesapla()"
          // ile bagli; Miktar ise burada KURU YOK SAYARAK
          // `Tutar = Miktar x BirimFiyat` yaziyordu. Dovizli faturada
          // birim fiyat doviz cinsindendir: 2 x 50 USD, kur 40 iken
          // Tutar 100 TL oluyordu (dogrusu 4000). Iki alan da ayni yolu
          // kullansin.
          this.dovizlitutarhesapla();
      }else{
          this.guncelleMiktarKontrol = 1;
      }


    },

    'SerbestFaturaDetay.Tutar': function (deger) {

      // DOVIZLI faturada doviz tutari KAYNAK, TL turetilmis olandir;
      // burada geri bolmek kullanicinin girdigi doviz rakamini yok eder:
      //
      //   3 x 12.345          = 37.0350 USD  (kullanici)
      //   x 41.9871, 2 haneye = 1554.99 TL
      //   / 41.9871           = 37.034946...
      //   kayitta toFixed(4)  = 37.0349 USD  <- girilen rakam kayboldu
      //
      // 30 kalemlik dovizli test faturasinin 8 satirinda olculdu.
      // TL alanina ELLE yazildiginda turetme gerekiyor; o is artik TL
      // alaninin kendi @input'unda (YuzdeKontrol).
      if (this.fatura.Dovizli !== true &&
          this.fatura.Kur != null && this.fatura.Kur != 0) {
          this.SerbestFaturaDetay.DovizTutar = this.SerbestFaturaDetay.Tutar / this.fatura.Kur
      }

      if (deger == 0) {
          this.SerbestFaturaDetay.IskontoYuzde = 0;
      }

      if (deger == 0 && this.SerbestFaturaDetay.KdvYuzde != 0) {
          this.SerbestFaturaDetay.KdvYuzde = 0
      }

      // Tutar degisti: iskonto -> kdv -> tevkifat zincirinin TAMAMI
      // yeniden hesaplanmali. Onceden yalnizca kdvhesapla() cagriliyordu,
      // bu yuzden Miktar degisince IskontoTutar eski Tutar'dan kalma
      // degerde kaliyor, KDV de o bayat iskontodan hesaplaniyordu.
      this.satirHesapla();
    },


    'SerbestFaturaDetay.IskontoYuzde': function () {
      // Iskonto KDV matrahini degistirir, KDV de tevkifat matrahini.
      // Onceden yalnizca IskontoTutar hesaplaniyordu; KDV bayat kaliyordu
      // (Tutar 300 / KDV %20 / iskonto %10 -> KDV 60 kaliyordu, 54 olmali).
      this.satirHesapla();
    },

    'SerbestFaturaDetay.KdvYuzde': function () {
      // KDV degisince tevkifat da degisir (tevkifat KDV uzerinden).
      this.satirHesapla();
    },

    'SerbestFaturaDetay.KdvTip': function () {
      // Haric <-> dahil gecisi KDV tutarini, o da tevkifati degistirir.
      this.satirHesapla();
    },

    'SerbestFaturaDetay.DovizTutar': function () {
      // Dovizli faturada iskonto/KDV/tevkifat DOVIZ tutarindan hesaplanir;
      // doviz degisip TL ayni kalsa bile zincir yenilenmeli.
      if (this.dovizEsasli()) this.satirHesapla();
    },
  },

  methods: {

    /** <reportbrosablon> bu bilesende; sayfanin Yazdir() metodu
     *  buradan cagiriyor. */
    reportbroYazdir(prm, pdfId) {
      return this.$refs.reportbrosablon.Print(prm, pdfId);
    },

    /* --- Asama 2a: sayfadan tasinan metotlar --- */
    /**
     * Liste ve hesap isteklerinin hata dali: sunucunun gercek aciklamasi, hangi istegin hata
     * verdigi basina yazilarak sayfaya iletilir (CLAUDE.md: HataMesajiCoz). Onceden hepsi sabit
     * Service Unavailable-... metni gosteriyordu; 429 ve is kurali mesajlari kayboluyordu.
     */
    istekHatasi(etiket, response) {
      this.$emit('hata', this.$t(etiket) + ': ' + tool.HataMesajiCoz(response, this.$t.bind(this)))
    },

    kurgetir(val) {

    var params1 = {
    Tarih: this.SerbestFatura.Tarih,
    DovizKod: this.SerbestFatura.Doviz.DovizKod
    }

    tool.api_post(this, 'Definitions/GetWebRate', params1).then((response) => {
      if (!(parseFloat(response.body) > 0)) {
        // Kur bulunamadi: onceden sessizce 1 yaziliyordu ve dovizli faturada TL tutarlar yanlis
        // cikiyordu. Alan bos (0) kalir, kullanici kuru elle girer; kur 0 iken kayit gitmez
        // (faturaIslemleri kurEksik).
        this.SerbestFatura.Kur = 0
        this.$emit('hata', this.$t('Exchange-Rate-Not-Found'))
      } else {
        this.SerbestFatura.Kur = response.body
      }
    }, (response) => {
        this.istekHatasi('Exchange-Rate', response)
    })

    },

    /**
     * Doviz cinsi secildi (v-autocomplete change). Kur 0 iken kuru SerbestFatura.Doviz.DovizKod
     * izleyicisi ister; burada da istenince kur iki kez gidiyordu. Kur doluyken (baska dovize
     * gecis) izleyici istemedigi icin kur burada istenir. Doviz cinsi temizlenince istek gitmez.
     */
    dovizSecildi(kod) {
      if (kod == null) { return; }
      if (parseFloat(this.SerbestFatura.Kur) > 0) {
        this.kurgetir('select');
      }
    },
    /**
     * Dizayn listesi faturanin doviz durumuna gore (dovizli / TL dizaynlari). Liste yalnizca dizayn
     * alani gorunuyorsa (gelen evrakta yok) ve doviz durumu son istenenden farkliysa istenir; yaniti
     * yalnizca en son istegin yaniti yazar. Onceden kayitli dovizli fatura acilirken once dovizsiz
     * (fatura yuklenmeden), sonra dovizli liste isteniyordu; gec donen ilk yanit dovizli listeyi
     * ezebiliyordu. Cagiranlar: yeni fatura acilisi (baslangicYukle), fatura yuklenmesi (fatura
     * izleyicisi) ve Dovizli isaretinin degismesi.
     */
    dizayngetir() {
        if (!this.dizayngoster) { return; }
        var dovizli = this.SerbestFatura.Dovizli === true;
        if (this.dizaynDovizli === dovizli) { return; }
        this.dizaynDovizli = dovizli;
        var istekNo = ++this.dizaynIstekNo;

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var params = {
            SirketKodu: credentials.SirketKodu,
            FaturaTip: 'S',
            DovizliFatura: dovizli,
            HatTipi: false,
            TumFiltre: true
        }

        tool.api_post(this, 'TicketInvoice/InvoiceMainTableList', params).then((response) => {
            if (istekNo !== this.dizaynIstekNo) { return; }
            this.dizaynsec = response.body
        }, (response) => {
            if (istekNo !== this.dizaynIstekNo) { return; }
            // Ayni doviz durumu icin yeniden istenebilsin.
            this.dizaynDovizli = null;
            this.istekHatasi('Select-Design', response)
        })

    },
    dizaynbilgigetir(Faturaid) {
        this.dizaynsec.forEach(element => {
            if (element.FaturaId == Faturaid) {
                this.SerbestFatura.EFaturaShowID.XsltID = element.FaturaXsltId
                this.SerbestFatura.EFaturaShowID.PdfID = element.FaturaPdfID
            }
        });
    },
    anatevkifatkdvkontrol() {
    // Kontrol edilen satir, duzenleme dialogundaki satirin ta kendisi.
    var detay = this.SerbestFaturaDetay

    if (this.SerbestFatura.TevkivatKdv != 0 && this.SerbestFatura.TevkivatKdv != null && this.SerbestFatura
    .TevkivatKdv !=
    '') {
    if (detay.TevkifatDetayOran != 0 && detay.TevkifatDetayOran != null && detay
        .TevkifatDetayOran != '') {

        this.$emit("hata", this.$t('Deduction-Rate-Selected-Free-Invoice-Detail-Screen'))
        this.SerbestFatura.TevkivatKdv = null

    } else {

        this.detaytevkifat = false
        detay.TevkifatDetayOran = 0
        detay.TevkifatDetayTutar = 0
    }

    } else {
    this.detaytevkifat = true
    }
    },
    anatevkifatiptal() {

    if (this.SerbestFatura.TevkivatKdv === 0 || this.SerbestFatura.TevkivatKdv === null || this.SerbestFatura
    .TevkivatKdv ===
    '') {
    this.detaytevkifat = true
    }
    },

    /**
     * Sayfanin mounted'indan, yetki kontrolunun icinden cagrilir.
     * Evrak tipi / doviz listelerini ceker ve rotaya gore fatura tipi,
     * dizayn ve KDV gorunurlugunu ayarlar.
     */
    baslangicYukle(params1) {
        tool.api_post(this, 'doctype/List', params1).then((response) => {
            this.EvrakTipi1 = response.body
            if(this.$route.query.islem == "yenigelenevrak"){
                this.SerbestFatura.Evrak.Evrakkod = 'AF';
            }else{
            this.SerbestFatura.Evrak.Evrakkod = 'SF';
            }
        }, (response) => {
            // Onceden bu dal BOSTU: liste alinamayinca Evrak Tipi sessizce
            // bos kaliyor, kullanici sebebini goremiyordu.
            this.istekHatasi('Document-Type', response)
        })

        tool.api_post(this, 'currency/List', params1).then((response) => {
            this.doviztipi = response.body
        }, (response) => {
            this.istekHatasi('Currency-Type', response)
        })

        if (this.$route.query.islem == "yeni" || this.$route.query.islem == "get") {
            this.dizayngoster = true
            // Kayitli fatura (get) acilirken liste fatura okununca istenir (fatura izleyicisi):
            // doviz durumu yuklenmeden istenirse dovizli faturada liste iki kez gidiyordu.
            if (this.$route.query.islem == "yeni") {
                this.dizayngetir()
            }
        }

        if (this.$route.query.islem == "yenigelenevrak" || this.$route.query.islem == "gelenevrak") {
            this.kdvShow = false;
            this.dizayngoster = false
            this.faturatipi = [];
            var kayit = {
                text: this.$t('Free-Purchase-Invoice'),
                value: 0
            }
            this.faturatipi.push(kayit);
            kayit = {
                text: this.$t('Sales-Return'),
                value: 1
            }
            this.faturatipi.push(kayit);

            this.gibserigoster = false;
            this.gibseri = [];
        }

        if (this.$route.query.islem == "get" || this.$route.query.islem == "gelenevrak") {
            this.seridisable = true
        }
    },

    /* --- Asama 2b/2c: sayfadan tasinan metotlar --- */
    /**
     * Cari bilgisi geldi: caricomp'un sendCurrentInfo olayi (Current/Get yaniti).
     * Istek caricomp'ta; burada yalnizca faturaya ozel alanlar kurulur. Onceden
     * bilesen ayni cariyi AYRICA getiriyordu: her secimde iki, serbestfatura'da
     * fatura acilirken uc istek gidiyordu.
     */
    cariBilgisiGeldi(bilgi) {
        if (!bilgi || !bilgi.Code) { return; }

        var credentials = JSON.parse(window.localStorage.getItem('credentials'))
        var response = { body: bilgi };
            this.SerbestFatura.EFaturaBilgi.Unvani = response.body.Title
            this.SerbestFatura.EFaturaBilgi.Unvani2 = response.body.Title2
            this.SerbestFatura.EFaturaBilgi.Adres1 = response.body.Invoice.Address
            this.SerbestFatura.EFaturaBilgi.IlceSehir = response.body.Invoice.Province
            this.SerbestFatura.EFaturaBilgi.Email = response.body.Email
            this.SerbestFatura.EFaturaBilgi.VergiDairesi = response.body.Invoice.TaxOffice
            this.SerbestFatura.EFaturaBilgi.VergiNo = response.body.Invoice.TaxNumber
            this.SerbestFatura.EFaturaBilgi.TcKimlikNo = response.body.Invoice.IdentityNumber
            this.SerbestFatura.EFaturaBilgi.Adi = response.body.Invoice.PerFirstName
            this.SerbestFatura.EFaturaBilgi.Soyadi = response.body.Invoice.PerFamilyName
            this.SerbestFatura.EFaturaBilgi.TUnvani = response.body.Invoice.PerTitle
            this.SerbestFatura.EFaturaBilgi.DigerAdi = response.body.Invoice.PerMiddleName
            this.SerbestFatura.EFaturaBilgi.OnAdiEki = response.body.Invoice.PerNameSuffix

            var vadegun=response.body.ExpiryDayGeneral;
            if (vadegun!=null && vadegun!='undefined')
            {
                try
                {
                    var date = this.SerbestFatura.Tarih.split("-");
      var changeDate = new Date(date[0], date[1] - 1, date[2]);
      changeDate.setDate(changeDate.getDate() + vadegun);
      var formatDate = helpers.dateformat(changeDate);
      var parseFormDate = formatDate.split(".");
      var nextDate =parseFormDate[2] + "-" + parseFormDate[1] + "-" + parseFormDate[0];
    var nextDateTime = nextDate + "T00:00:00";
      this.SerbestFatura.Vade=nextDateTime;
                }
                catch
                {

                }
               
               
               
            }
            
            
            // Masraf merkezi carinin varsayilanindan gelir; YUKLENEN faturanin kendi carisi
            // icin gelen ilk bilgide faturadaki kayitli deger korunur. Onceden bu, cagri
            // SAYISINA bakilarak yapiliyordu; acilista birden fazla istek
            // gittigi icin ilkinden sonraki yanit kayitli degeri eziyordu.
            var yuklenenCari = this.yuklenenCariKod;
            this.yuklenenCariKod = null;
            if (this.$route.query.islem != "get" || String(bilgi.Code).trim() !== String(yuklenenCari || "").trim()) {
                this.SerbestFatura.Masraf.Code = response.body.ExpenseCenter;
            }

            this.gonderimsekli.forEach(element => {
            if (response.body.EInvoiceType == element.value) {

                this.gonderimlabel = element.text
            }
            });

            if (response.body.EArchiveSendType==true && response.body.EArchiveSendPaper==false)
            {
                this.gonderimlabel=this.$t('Electronic')
                this.SerbestFatura.EarsivBilgi.GonderimSekli=1;
            }
            this.efaturatipigecici = String(response.body.EInvoiceType);
            if(response.body.EInvoiceType == 2){
                this.ihracat = true
            }else{
                this.ihracat = false
            }
            //ana sirket e faturacı değilse kağıt fatura
            if (credentials.EFatura != '1') {

                this.SerbestFatura.Efaturakayit = false
                this.SerbestFatura.Earchiveakayit = false
                this.SerbestFatura.KagitFatura = true
            }

            if (credentials.EFatura == '1' && response.body.EInvoiceCustomer == '1') {
                // ana sirket efatura cari efatura o zaman efaturacı
                this.SerbestFatura.Efaturakayit = true
                this.SerbestFatura.Earchiveakayit = false
                this.SerbestFatura.KagitFatura = false

            }

            if (credentials.EFatura == '1' && response.body.EInvoiceCustomer == '0') {
                if (credentials.EArsiv == '1') {
                    //anasirket efatura cari earsiv  o zaman earşivci
                    this.SerbestFatura.Earchiveakayit = true
                    this.SerbestFatura.Efaturakayit = false
                    this.SerbestFatura.KagitFatura = false
                } else {
                    this.SerbestFatura.Earchiveakayit = false
                    this.SerbestFatura.Efaturakayit = false
                    this.SerbestFatura.KagitFatura = true
                }
            }

            var params1 = {
                CompanyCode: credentials.SirketKodu,
                PassiveControl: true,

            }

            if (this.SerbestFatura.Efaturakayit == true) {

                if (this.$route.query.islem != "yenigelenevrak" && this.$route.query.islem != "gelenevrak") {
                    this.gibserigoster = true;
                }

                tool.api_post(this, 'Definitions/GibSerialList', params1).then((response) => {
                    this.gibseri = response.body
                }, (response) => {
                    this.istekHatasi('Gib-Series', response)
                })

            } else if (this.SerbestFatura.Earchiveakayit == true) {

                if (this.$route.query.islem != "yenigelenevrak" && this.$route.query.islem != "gelenevrak") {
                    this.gibserigoster = true;
                }

                tool.api_post(this, 'Definitions/GibSerialEarchiveList', params1).then((response) => {
                    this.gibseri = response.body
                }, (response) => {
                    this.istekHatasi('Gib-Series', response)
                })

            } else if (this.SerbestFatura.KagitFatura == true) {
                this.gibserigoster = false;
            }


    },
    /**
     * E-arsiv bilgi girisi: pencereyi acar, web adresi / odeme sekli / odeme araci listelerini
     * getirir. Buton kaydetbutonu (CLAUDE.md): listeler gelene kadar pasif kalsin diye uc istegin
     * Promise'i birlikte DONDURULUR.
     */
    earsivbilgigir() {
      this.dialogearsiv = true

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      var liste = (tip, etiket, yaz) => tool.api_post(this, 'Definitions/GeneralTypeList', {
        CompanyCode: credentials.SirketKodu,
        Type: tip,
      }).then((response) => { yaz(response.body) }, (response) => { this.istekHatasi(etiket, response) })

      return Promise.all([
        liste('305', 'Web-Address', (v) => { this.webadresleri = v }),
        liste('306', 'Payment-Method', (v) => { this.odemesekilleri = v }),
        liste('307', 'Payment-Instrument', (v) => { this.odemearaci = v }),
      ])
    },

    /** "yyyy-aa-gg" -> "gg-aa-yyyy". Yalnizca e-arsiv odeme tarihi
     *  etiketi icin kullaniliyor. */
    tarihkontrol(v) {

        if (v != "0001-01-01T00:00:00" && v != null) {
            var parts1 = v.split("-");
            return (parts1[2] + '-' + parts1[1] + '-' + parts1[0]);
        } else {
            return null;
        }
    },

    /**
     * Fatura toplamlarini SATIRLARDAN SIFIRDAN hesaplar.
     *
     * Onceden satir ekle/guncelle/sil toplamlari ELLE ve ARTIMLI
     * duzeltiyordu (Tutarlar.ToplamTutar -= ... += ...). Bir satir iki
     * kez dusulur ya da hic dusulmezse baslik satirlarla tutmuyordu ve
     * bunu fark etmenin yolu yoktu. Sifirdan hesaplamak o hata sinifini
     * tumden kaldiriyor.
     */
    /**
     * Dovizli faturada kur degisince TUM kalemleri yeni kura tasir.
     *
     * Doviz tutari kalemin kendi verisi olarak SABIT kalir;
     * TL tutari = DovizTutar x Kur (2 haneye, SQL ROUND kurali ile).
     * Ardindan satirin iskonto/KDV/tevkifat zinciri yeni TL tutar
     * uzerinden bastan hesaplanir -- yoksa KDV eski tutarin KDV'si
     * olarak kalirdi.
     */
    kalemleriKuraGoreYenile(kur) {
      const liste = this.kalemler;
      if (!Array.isArray(liste) || liste.length === 0) { return; }

      for (let i = 0; i < liste.length; i++) {
        const satir = liste[i];
        const dovizTutar = parseFloat(satir.DovizTutar);
        if (!(dovizTutar > 0)) { continue; }

        // Doviz sabit; TL'nin tamami dovizden yeniden turer.
        const yeni = hesap.dovizSatirHesapla(satir, kur);
        satir.Tutar = yeni.Tutar;
        satir.IskontoTutar = yeni.IskontoTutar;
        satir.KdvTutar = yeni.KdvTutar;
        satir.TevkifatDetayTutar = yeni.TevkifatDetayTutar;
      }

      this.toplamlariYenile();
    },

    toplamlariYenile() {
      // $nextTick SART: satir guncellemede liste `this.kalemler = yeni`
      // ile degisiyor, bu bir COMPUTED SETTER ve $emit('input') yapiyor.
      // Prop ancak ebeveyn yeniden ciziince guncelleniyor; ayni tick'te
      // okunursa ESKI dizi gelir ve baslik satirlarla tutmaz (ekranda
      // yakalandi: satir 700 olurken baslik 200.01 kaliyordu).
      this.$nextTick(function () {
        var t = hesap.faturaToplamlari(this.kalemler);
        this.fatura.Tutarlar.ToplamTutar = t.ToplamTutar;
        this.fatura.Tutarlar.Kdv = t.Kdv;
        this.fatura.Tutarlar.Iskonto = t.Iskonto;
        this.fatura.Tutarlar.TevkifatKdv = t.TevkifatKdv;
        this.fatura.Tutarlar.FaturaToplam = t.FaturaToplam;
      }.bind(this));
    },

    /** helpers gecisi; sablon ifadelerinden cagriliyor. */
    getparabirimi() { return helpers.getparabirimi(); },
    getdefaultparabirimi(m) { return helpers.getparabirimiDefault(m); },

    /* Asama 1: bu isler hala sayfada duruyor, bilesen olay yayiyor. */

    satirekle() {
      this.satirGuncelleniyor = false   // yeni islem basliyor

      this.SerbestFaturaDetay.Referans.Kod = null
      this.satirdialog = true
      this.satirkaydetbuton = true
      this.satirguncellebuton = false
      this.SerbestFaturaDetay.MuhasebeKodu = ''
      this.SerbestFaturaDetay.MuhasebeKodu = ''
      this.SerbestFaturaDetay.Aciklama = ''
      this.SerbestFaturaDetay.LineNote = ''
      this.SerbestFaturaDetay.Masraf.Code = null
      this.SerbestFaturaDetay.Miktar = ''
      this.SerbestFaturaDetay.Birim = ''
      this.SerbestFaturaDetay.BirimFiyat = 0
      this.SerbestFaturaDetay.Tutar = 0
      this.SerbestFaturaDetay.DovizTutar = 0
      this.SerbestFaturaDetay.IskontoYuzde = 0
      this.SerbestFaturaDetay.IskontoTutar = 0
      this.SerbestFaturaDetay.KdvTip = 'D'
      this.SerbestFaturaDetay.KdvYuzde = 0
      this.SerbestFaturaDetay.KdvTutar = 0
      this.SerbestFaturaDetay.KdvMuhKodu = ''
      this.SerbestFaturaDetay.IskMuhKodu = ''
      this.SerbestFaturaDetay.KdvKodu = ''
      this.SerbestFaturaDetay.IstisnaKodu = ''
      this.SerbestFaturaDetay.TevkifatKodu = ''
      this.SerbestFaturaDetay.Tip = ''
      this.SerbestFaturaDetay.TevkifatDetayTutar = 0
      this.SerbestFaturaDetay.TevkifatDetayOran = ''
      this.SerbestFaturaDetay.TeslimBilgileri.SokakAdi = ''
      this.SerbestFaturaDetay.TeslimBilgileri.BinaAdi = ''
      this.SerbestFaturaDetay.TeslimBilgileri.BinaNo = ''
      this.SerbestFaturaDetay.TeslimBilgileri.TeslimSehir = ''
      this.SerbestFaturaDetay.TeslimBilgileri.TeslimPostaKodu = ''
      this.SerbestFaturaDetay.TeslimBilgileri.TeslimUlke = ''
      this.SerbestFaturaDetay.TeslimBilgileri.TeslimSarti = ''
      this.SerbestFaturaDetay.TeslimBilgileri.GTIPNo = ''
      this.SerbestFaturaDetay.TeslimBilgileri.TransferKodu = ''
      this.SerbestFaturaDetay.TeslimBilgileri.KabinNo = ''
      this.SerbestFaturaDetay.TeslimBilgileri.KabinAdedi = ''
      this.SerbestFaturaDetay.TeslimBilgileri.KabinCinsi = ''
      this.SerbestFaturaDetay.TeslimBilgileri.TeslimOdeme = ''

    },

    satirkaydet() {
      // Buton kaydetbutonu: cift tiklama kilidi bilesende, burada kilit tutulmaz (CLAUDE.md).


          var islem = false

          if (this.$route.query.islem == "yenigelenevrak" )
          {
              islem=true;
              if (this.SerbestFaturaDetay.KdvYuzde == 0)
              {
                  this.SerbestFaturaDetay.KdvKodu = '0015'
              }
          }
          else
          {
              if (this.SerbestFaturaDetay.KdvYuzde == 0) {

      this.SerbestFaturaDetay.KdvKodu = '0015'

      if (this.SerbestFaturaDetay.IstisnaKodu != null && this.SerbestFaturaDetay.IstisnaKodu != '') {

          if ((this.fatura.TevkivatKdv != null && this.fatura.TevkivatKdv != '') || (this
                  .SerbestFaturaDetay
                  .TevkifatDetayOran != '' && this.SerbestFaturaDetay.TevkifatDetayOran != null)) {

              if (this.SerbestFaturaDetay.TevkifatKodu != null && this.SerbestFaturaDetay.TevkifatKodu != '') {
                  islem = true
              } else {
                  this.$emit('hata', this.$t('Withholding-Code-cannot-be-left-blank.'))
                  islem = false
              }
          } else {
              islem = true
          }
      } else {
          islem = false
          this.$emit('hata', this.$t('Please-fill-in-the-required-fields.'))
      }
      } else {

      if (this.SerbestFaturaDetay.KdvKodu != null && this.SerbestFaturaDetay.KdvKodu != '') {

          if ((this.fatura.TevkivatKdv != null && this.fatura.TevkivatKdv != '') || (this
                  .SerbestFaturaDetay
                  .TevkifatDetayOran != '' && this.SerbestFaturaDetay.TevkifatDetayOran != null)) {

              if (this.SerbestFaturaDetay.TevkifatKodu != null && this.SerbestFaturaDetay.TevkifatKodu != '') {
                  islem = true
              } else {
                  this.$emit('hata', this.$t('Please-fill-in-the-required-fields.'))
                  islem = false
              }
          } else {
              islem = true
          }

      } else {
          this.$emit('hata', this.$t('Please-fill-in-the-required-fields.'))
          islem = false

      }

      }
          }



          if (islem == true) {
              this.guncelleMiktarKontrol = 0;

              if (this.SerbestFaturaDetay.DovizTutar > 0) {
                  var n = this.SerbestFaturaDetay.DovizTutar
                  this.SerbestFaturaDetay.DovizTutar = n.toFixed(4)

              }

              var satir = {
                  TeslimBilgileri: {
                      SokakAdi: this.SerbestFaturaDetay.TeslimBilgileri.SokakAdi,
                      BinaAdi: this.SerbestFaturaDetay.TeslimBilgileri.BinaAdi,
                      BinaNo: this.SerbestFaturaDetay.TeslimBilgileri.BinaNo,
                      TeslimSehir: this.SerbestFaturaDetay.TeslimBilgileri.TeslimSehir,
                      TeslimPostaKodu: this.SerbestFaturaDetay.TeslimBilgileri.TeslimPostaKodu,
                      TeslimUlke: this.SerbestFaturaDetay.TeslimBilgileri.TeslimUlke,
                      TeslimSarti: this.SerbestFaturaDetay.TeslimBilgileri.TeslimSarti,
                      GTIPNo: this.SerbestFaturaDetay.TeslimBilgileri.GTIPNo,
                      TransferKodu: this.SerbestFaturaDetay.TeslimBilgileri.TransferKodu,
                      KabinNo: this.SerbestFaturaDetay.TeslimBilgileri.KabinNo,
                      KabinAdedi: this.SerbestFaturaDetay.TeslimBilgileri.KabinAdedi,
                      KabinCinsi: this.SerbestFaturaDetay.TeslimBilgileri.KabinCinsi,
                      TeslimOdeme: this.SerbestFaturaDetay.TeslimBilgileri.TeslimOdeme
                  },
                  MuhasebeKodu: this.SerbestFaturaDetay.MuhasebeKodu,
                  Aciklama: this.SerbestFaturaDetay.Aciklama,
                  Referans: {
                      Kod: this.SerbestFaturaDetay.Referans.Kod
                  },
                  Masraf: {
                      Code: this.SerbestFaturaDetay.Masraf.Code
                  },
                  Miktar: this.SerbestFaturaDetay.Miktar,
                  LineNote: this.SerbestFaturaDetay.LineNote,
                  Birim: this.SerbestFaturaDetay.Birim,
                  BirimFiyat: this.SerbestFaturaDetay.BirimFiyat,
                  Tutar: this.SerbestFaturaDetay.Tutar,
                  TevkifatDetayTutar: this.SerbestFaturaDetay.TevkifatDetayTutar,
                  DovizTutar: this.SerbestFaturaDetay.DovizTutar,
                  TevkifatDetayOran: this.SerbestFaturaDetay.TevkifatDetayOran,
                  IskontoYuzde: this.SerbestFaturaDetay.IskontoYuzde,
                  IskontoTutar: this.SerbestFaturaDetay.IskontoTutar,
                  KdvKodu: this.SerbestFaturaDetay.KdvKodu,
                  KdvMuhKodu: this.SerbestFaturaDetay.KdvMuhKodu, //
                  IskMuhKodu: this.SerbestFaturaDetay.IskMuhKodu, //
                  KdvTutar: this.SerbestFaturaDetay.KdvTutar,
                  KdvTip: this.SerbestFaturaDetay.KdvTip,
                  KdvYuzde: this.SerbestFaturaDetay.KdvYuzde,
                  IstisnaKodu: this.SerbestFaturaDetay.IstisnaKodu,
                  TevkifatKodu: this.SerbestFaturaDetay.TevkifatKodu,
                  Tip: this.SerbestFaturaDetay.Tip,
                  AdresBilgi: {
                      Unvani: null,
                      Unvani2: null,
                      Adres1: null,
                      Adres2: null,
                      IlceSehir: null,
                      Email: null,
                      VergiDairesi: null,
                      VergiNo: null,
                      TcKimlikNo: null,
                      Adi: null,
                      Soyadi: null,
                      TUnvani: null,
                      DigerAdi: null,
                      OnAdiEki: null
                  },
                  EfaturaDetayBilgileri: {
                      SiparisID: null,
                      SiparisTarihi: null
                  },
                  AdresBilgi: {
                      Unvani: null,
                      Unvani2: null,
                      Adres1: null,
                      Adres2: null,
                      IlceSehir: null,
                      Email: null,
                      VergiDairesi: null,
                      VergiNo: null,
                      TcKimlikNo: null,
                      Adi: null,
                      Soyadi: null,
                      TUnvani: null,
                      DigerAdi: null,
                      OnAdiEki: null
                  }
              }

              this.kalemler.push(satir);
      this.toplamlariYenile();

              this.satirdialog = false
              this.$emit('degisti');

          }


    },

    satirSeciliMi(kalem) {
      return this.secilenKalemler.indexOf(kalem) >= 0;
    },

    satirSec(kalem, secili) {
      var digerleri = this.secilenKalemler.filter(function (k) { return k !== kalem; });
      this.secilenKalemler = secili ? digerleri.concat([kalem]) : digerleri;
    },

    tumunuSec(secili) {
      this.secilenKalemler = secili ? this.kalemler.slice() : [];
    },

    topluMuhasebeAc() {
      if (this.seciliKalemler.length === 0) { return; }
      this.topluMuhasebeKodu = '';
      this.topluMuhasebeDialog = true;
    },

    /**
     * Secili kalemlere ayni muhasebe kodunu yazar.
     *
     * kalemler computed: diziyi yerinde degistirmek ebeveyne ulasmaz
     * (bkz. satirguncellekaydet). Yeni liste kurulur, secili satirlar
     * KOPYALANARAK degistirilir ve tek seferde atanir. Tutar degismedigi
     * icin toplamlar yeniden hesaplanmaz.
     */
    topluMuhasebeUygula() {
      if (!this.topluMuhasebeKoduGecerli) { return; }

      var kod = this.topluMuhasebeKodu.trim();
      var secili = this.seciliKalemler;

      if (secili.length > 0) {
        this.kalemler = this.kalemler.map(function (k) {
          return secili.indexOf(k) >= 0 ? Object.assign({}, k, { MuhasebeKodu: kod }) : k;
        });
        this.$emit('degisti');
      }

      this.secilenKalemler = [];
      this.topluMuhasebeDialog = false;
    },

    satirduzenle(params) {
      this.satirGuncelleniyor = false   // yeni islem basliyor


      this.yedeksatirkayit.Tutar = params.Tutar
      this.yedeksatirkayit.Kdv = params.KdvTutar
      this.yedeksatirkayit.iskonto = params.IskontoTutar
      this.yedeksatirkayit.Tevkifat = params.TevkifatDetayTutar
      this.secilensatirno = this.kalemler.indexOf(params)
      this.degisenkayit = params
      this.secilenkdvtipi = params.KdvTip
      this.SerbestFaturaDetay = {...params}
      this.satirdialog = true
      this.satirguncellebuton = true
      this.satirkaydetbuton = false

    },

    satirsilsor(item) {
      this.satirSiliniyor = false   // yeni islem basliyor

      this.dialogsor = true;
      this.satirsilbtn = true,
          this.silinecekkayit = item

    },

    satirsil() {
      // Cift tiklama korumasi: satir/toplamlar iki kez silinmesin.
      if (this.satirSiliniyor) { return }
      this.satirSiliniyor = true


      const index = this.kalemler.indexOf(this.silinecekkayit)

      this.kalemler.splice(index, 1)
      this.toplamlariYenile()
      this.dialogsor = false;
      this.$emit('degisti');

    },

    satirDialogIptal() {

      this.satirdialog = false;
      this.guncelleMiktarKontrol = 0;

    },

    satirguncellekaydet() {
      // Cift tiklama korumasi: toplamlar iki kez duzeltilmesin.
      if (this.satirGuncelleniyor) { return }
      this.satirGuncelleniyor = true



                  var islem = false

                  if (this.$route.query.islem == "yenigelenevrak")
                  {
                      if (this.SerbestFaturaDetay.KdvYuzde == 0)
                      {
                          this.SerbestFaturaDetay.KdvKodu = '0015'
                      }
                      islem=true
                  }
      else
      {
          if (this.SerbestFaturaDetay.KdvYuzde == 0) {

      this.SerbestFaturaDetay.KdvKodu = '0015'

      if ( this.SerbestFaturaDetay.IstisnaKodu != null && this.SerbestFaturaDetay.IstisnaKodu != '') {

          if ((this.fatura.TevkivatKdv != null && this.fatura.TevkivatKdv != '') || (this
                  .SerbestFaturaDetay
                  .TevkifatDetayOran != '' && this.SerbestFaturaDetay.TevkifatDetayOran != null)) {

              if (this.SerbestFaturaDetay.TevkifatKodu != null && this.SerbestFaturaDetay.TevkifatKodu != '') {
                  islem = true
              } else {
                  this.$emit('hata', this.$t('Withholding-Code-cannot-be-left-blank.'))
                  this.satirGuncelleniyor = false
                  islem = false
              }
          } else {
              islem = true
          }
      } else {
          islem = false
          this.$emit('hata', this.$t('You-cannot-pass-the-exception-code-blank.'))
          this.satirGuncelleniyor = false
      }
      } else {

      if ( this.SerbestFaturaDetay.KdvKodu != null && this.SerbestFaturaDetay.KdvKodu != '') {

          if ((this.fatura.TevkivatKdv != null && this.fatura.TevkivatKdv != '') || (this
                  .SerbestFaturaDetay
                  .TevkifatDetayOran != '' && this.SerbestFaturaDetay.TevkifatDetayOran != null)) {

              if (this.SerbestFaturaDetay.TevkifatKodu != null && this.SerbestFaturaDetay.TevkifatKodu != '') {
                  islem = true
              } else {
                  this.$emit('hata', this.$t('Withholding-Code-cannot-be-left-blank.'))
                  this.satirGuncelleniyor = false
                  islem = false
              }
          } else {
              islem = true
          }

      } else {
          this.$emit('hata', this.$t('VAT-Code-cannot-be-left-blank.'))
          this.satirGuncelleniyor = false
          islem = false

      }
      }
      }


                  if(islem == true){
                      const index = this.secilensatirno

                      var degisenkayit = {}

                      var yedeksatiritems = []

                      // `kalemler` computed oldugu icin `this.kalemler = []`
                      // diziyi yerinde degistirmez. Eski listeyi kopyala,
                      // yenisini ayri kur, sonunda tek seferde ata.
                      yedeksatiritems = this.kalemler.slice()

                      var yeniKalemler = []

      if (this.SerbestFaturaDetay.TevkifatDetayOran==0)
      {
          this.fatura.Tutarlar.TevkifatKdv=0;
          this.yedeksatirkayit.Tevkifat=0;
      }





                      if (this.SerbestFaturaDetay.DovizTutar > 0) {
                          var n = this.SerbestFaturaDetay.DovizTutar

                      }
                      this.guncelleMiktarKontrol = 0;

                      var satiryeni = {
                          TeslimBilgileri: {
                              SokakAdi: this.SerbestFaturaDetay.TeslimBilgileri.SokakAdi,
                              BinaAdi: this.SerbestFaturaDetay.TeslimBilgileri.BinaAdi,
                              BinaNo: this.SerbestFaturaDetay.TeslimBilgileri.BinaNo,
                              TeslimSehir: this.SerbestFaturaDetay.TeslimBilgileri.TeslimSehir,
                              TeslimPostaKodu: this.SerbestFaturaDetay.TeslimBilgileri.TeslimPostaKodu,
                              TeslimUlke: this.SerbestFaturaDetay.TeslimBilgileri.TeslimUlke,
                              TeslimSarti: this.SerbestFaturaDetay.TeslimBilgileri.TeslimSarti,
                              GTIPNo: this.SerbestFaturaDetay.TeslimBilgileri.GTIPNo,
                              TransferKodu: this.SerbestFaturaDetay.TeslimBilgileri.TransferKodu,
                              KabinNo: this.SerbestFaturaDetay.TeslimBilgileri.KabinNo,
                              KabinAdedi: this.SerbestFaturaDetay.TeslimBilgileri.KabinAdedi,
                              KabinCinsi: this.SerbestFaturaDetay.TeslimBilgileri.KabinCinsi,
                              TeslimOdeme: this.SerbestFaturaDetay.TeslimBilgileri.TeslimOdeme
                          },
                          MuhasebeKodu: this.SerbestFaturaDetay.MuhasebeKodu,
                          Aciklama: this.SerbestFaturaDetay.Aciklama,
                          Referans: {
                              Kod: this.SerbestFaturaDetay.Referans.Kod
                          },
                          Masraf: {
                              Code: this.SerbestFaturaDetay.Masraf.Code
                          },
                          Miktar: this.SerbestFaturaDetay.Miktar,
                          LineNote: this.SerbestFaturaDetay.LineNote,
                          Birim: this.SerbestFaturaDetay.Birim,
                          BirimFiyat: this.SerbestFaturaDetay.BirimFiyat,
                          Tutar: this.SerbestFaturaDetay.Tutar,
                          TevkifatDetayTutar: this.SerbestFaturaDetay.TevkifatDetayTutar,
                          DovizTutar: this.SerbestFaturaDetay.DovizTutar,
                          TevkifatDetayOran: this.SerbestFaturaDetay.TevkifatDetayOran,
                          IskontoYuzde: this.SerbestFaturaDetay.IskontoYuzde,
                          IskontoTutar: this.SerbestFaturaDetay.IskontoTutar,
                          KdvKodu: this.SerbestFaturaDetay.KdvKodu,
                          KdvMuhKodu: this.SerbestFaturaDetay.KdvMuhKodu, //
                          IskMuhKodu: this.SerbestFaturaDetay.IskMuhKodu, //
                          KdvTutar: this.SerbestFaturaDetay.KdvTutar,
                          KdvTip: this.SerbestFaturaDetay.KdvTip,
                          KdvYuzde: this.SerbestFaturaDetay.KdvYuzde,
                          IstisnaKodu: this.SerbestFaturaDetay.IstisnaKodu,
                          TevkifatKodu: this.SerbestFaturaDetay.TevkifatKodu,
                          Tip: this.SerbestFaturaDetay.Tip,
                          AdresBilgi: {
                              Unvani: null,
                              Unvani2: null,
                              Adres1: null,
                              Adres2: null,
                              IlceSehir: null,
                              Email: null,
                              VergiDairesi: null,
                              VergiNo: null,
                              TcKimlikNo: null,
                              Adi: null,
                              Soyadi: null,
                              TUnvani: null,
                              DigerAdi: null,
                              OnAdiEki: null
                          },
                          EfaturaDetayBilgileri: {
                              SiparisID: null,
                              SiparisTarihi: null
                          },
                          AdresBilgi: {
                              Unvani: null,
                              Unvani2: null,
                              Adres1: null,
                              Adres2: null,
                              IlceSehir: null,
                              Email: null,
                              VergiDairesi: null,
                              VergiNo: null,
                              TcKimlikNo: null,
                              Adi: null,
                              Soyadi: null,
                              TUnvani: null,
                              DigerAdi: null,
                              OnAdiEki: null
                          }
                      }

                      for (var i = 0; i < yedeksatiritems.length; i++) {
                          if (index == i) {
                              yeniKalemler.push(satiryeni);
                          } else {
                              yeniKalemler.push(yedeksatiritems[i]);
                          }
                      }

                      this.kalemler = yeniKalemler
                      this.toplamlariYenile()

                      this.satirdialog = false;

                      this.$emit('degisti');

                  }

    },

    /**
     * ACIK OLAN SATIRIN TUM TUTARLARI -- bagimlilik sirasiyla:
     *   Tutar -> IskontoTutar -> KdvTutar -> TevkifatDetayTutar
     *
     * Sira faturaHesap.satirHesapla'da duruyor (saf, birim testli);
     * burasi yalnizca sonucu satira yaziyor.
     *
     * Alanlarin izleyicileri artik tek tek degil BU metodu cagiriyor:
     * her alan yalnizca kendi hesabini yapinca zincirin gerisi bayat
     * kaliyordu (iskonto girilince KDV eski matrahta kaliyor, Miktar
     * degisince iskonto eski Tutar'dan kalma oluyordu).
     */
    satirHesapla() {
      // Dovizli faturada zincir DOVIZ tutari uzerinden kurulur, TL
      // karsiliklari dovizden turer (kural ve gerekcesi:
      // faturaHesap.dovizSatirHesapla). Tutar'a burada DOKUNULMAZ ki TL
      // alani elle yazilirken her tusta ezilmesin; TL tutari dovizden
      // tureten yerler: dovizlitutarhesapla, satirDovizOdakKaybi,
      // satirTutarOdakKaybi, kalemleriKuraGoreYenile.
      const s = this.dovizEsasli()
        ? hesap.dovizSatirHesapla(this.SerbestFaturaDetay, this.fatura.Kur)
        : hesap.satirHesapla(this.SerbestFaturaDetay);
      this.SerbestFaturaDetay.IskontoTutar = s.IskontoTutar;
      this.SerbestFaturaDetay.KdvTutar = s.KdvTutar;
      this.SerbestFaturaDetay.TevkifatDetayTutar = s.TevkifatDetayTutar;
    },

    /** Dovizli fatura ve gecerli kur varsa hesap doviz esasli yurur. */
    dovizEsasli() {
      return this.fatura.Dovizli === true && parseFloat(this.fatura.Kur) > 0;
    },

    /* Sablondaki @change'in eski adi; satirHesapla zincirini calistiriyor. */
    Tevkifatkdvhesapla() { this.satirHesapla(); },

    dovizlitutarhesapla() {

      if (this.SerbestFaturaDetay.Miktar > 0 && this.SerbestFaturaDetay.BirimFiyat >= 0) {
          // DOVIZ TUTARI 2 HANE: e-faturada doviz tutarlari noktadan sonra
          // 2 hane olmak zorunda. Yuvarlama BURADA yapiliyor ki TL tutar da
          // ayni 2 haneli degerden turesin. Onceden doviz yuvarlanmamis
          // haliyle kurla carpiliyor, sonra kayitta 2'ye kirpiliyordu; satir
          // kendi icinde tutmuyordu (olculdu: 7 x 1,115 = 7,805 -> kayitta
          // doviz 7,80 ama TL 327,71, oysa 7,80 x 41,9871 = 327,50).
          this.SerbestFaturaDetay.DovizTutar =
            hesap.round2(this.SerbestFaturaDetay.Miktar * this.SerbestFaturaDetay.BirimFiyat)
           if (this.fatura.Kur != null && this.fatura.Kur != 0 && this.fatura.Dovizli == true) {
             this.SerbestFaturaDetay.Tutar = hesap.carpimYuvarla2(this.SerbestFaturaDetay.DovizTutar, this.fatura.Kur)
           }else{
              this.SerbestFaturaDetay.Tutar = hesap.round2(this.SerbestFaturaDetay.Miktar * this.SerbestFaturaDetay.BirimFiyat)
           }
      } else {
          this.SerbestFaturaDetay.Tutar = 0
      }

    },

    /**
     * TL "Tutar" alanindan cikilinca birim fiyat da tutara uyar.
     *
     * satirDovizOdakKaybi ile AYNI kusur bu tarafta da vardi: TL tutar elle
     * degistirilince Miktar ve BirimFiyat oldugu gibi kaliyor, satir kendi
     * icinde tutmuyordu; kullanici sonradan Miktar'a dokununca
     * dovizlitutarhesapla() girilen tutari Miktar x BirimFiyat ile
     * SESSIZCE eziyordu.
     *
     * Kaynak Dovizli'ye gore secilir: dovizli faturada birim fiyat DOVIZ
     * cinsindendir (sablonda etiketi de oyle) ve dovizlitutarhesapla
     * `DovizTutar = Miktar x BirimFiyat` kuruyor; dovizsizde birim fiyat TL
     * ve `Tutar = Miktar x BirimFiyat`.
     */
    satirTutarOdakKaybi() {
      const d = this.SerbestFaturaDetay;

      // Dovizli faturada TL elle yazilsa da kaynak DOVIZDIR: yazilan TL'den
      // 2 haneli doviz bulunur, TL de o dovizden yeniden turer (e-fatura
      // doviz cinsinden; bkz. faturaHesap.dovizSatirHesapla). Yazilan TL
      // bu yuzden birkac kurus degisebilir: 1000 TL / 41,9871 = 23,82 USD
      // -> 1000,13 TL.
      if (this.dovizEsasli()) {
        const tl = parseFloat(d.Tutar);
        if (!isNaN(tl)) {
          d.DovizTutar = hesap.round2(tl / this.fatura.Kur);
          d.Tutar = hesap.carpimYuvarla2(d.DovizTutar, this.fatura.Kur);
        }
      }

      const kaynak = this.fatura.Dovizli === true ? d.DovizTutar : d.Tutar;

      const birimFiyat = hesap.birimFiyatTuret(kaynak, d.Miktar);
      if (birimFiyat !== null) {
          d.BirimFiyat = birimFiyat;
      }
    },

    satirDovizOdakKaybi(val) {


      // Iki dal da ayni islemi yapiyordu (kaynaktaki hali); tutar artik
      // 2 haneye yuvarlaniyor ki satirlarin toplami baslikla tutsun.
      const d = this.SerbestFaturaDetay;
      // Elle girilen doviz tutari da 2 haneye yuvarlanir (e-fatura kurali);
      // birim fiyat ve TL tutar bu degerden turesin ki satir tutarli kalsin.
      const dovizTutar = hesap.round2(parseFloat(d.DovizTutar));
      if (isNaN(dovizTutar) || dovizTutar === 0) { return; }
      d.DovizTutar = dovizTutar;

      // DOVIZ TUTARI ELLE DEGISTIRILDIGINDE BIRIM FIYAT DA UYMALI.
      // Onceden yalnizca TL tutar guncelleniyordu; satir kendi icinde
      // tutarsiz kaliyordu (Miktar 2 / BirimFiyat 50 iken doviz 150
      // yazilinca 2 x 50 = 100 ile 150 tutmuyor) ve daha kotusu, kullanici
      // sonradan Miktar'a dokununca dovizlitutarhesapla() girilen degeri
      // Miktar x BirimFiyat ile SESSIZCE eziyordu (olculdu: 150 -> 250).
      //
      // Turetme kurali (ve NEDEN yuvarlanmadigi) faturaHesap'ta; orada
      // birim testi de var.
      const birimFiyat = hesap.birimFiyatTuret(dovizTutar, d.Miktar);
      if (birimFiyat !== null) {
          d.BirimFiyat = birimFiyat;
      }

      d.Tutar = hesap.carpimYuvarla2(dovizTutar, this.fatura.Kur);


    },

    /**
     * TL "Tutar" alaninin @input'u. Kullanici TL'yi ELLE yazdiginda
     * kaynak TL'dir; doviz karsiligi ondan turetilir. (Dovizli faturada
     * Tutar izleyicisi artik DovizTutar'a dokunmuyor -- Miktar/BirimFiyat
     * girisinde girilen doviz rakami aynen kalsin diye.)
     *
     * Iskonto/KDV/tevkifat hesabi buradan KALDIRILDI: buradaki kopya
     * yuvarlamasiz calisiyordu (Tutar / 100 * IskontoYuzde). Tutar
     * izleyicisi zaten satirHesapla() ile tam zinciri calistiriyor.
     */
    YuzdeKontrol() {
      if (this.fatura.Dovizli === true &&
          this.fatura.Kur != null && this.fatura.Kur != 0) {
          this.SerbestFaturaDetay.DovizTutar =
            this.SerbestFaturaDetay.Tutar / this.fatura.Kur
      }
    },

    getparabirimi() {

      return helpers.getparabirimi()

    },

    getdefaultparabirimi(m) {
      return helpers.getparabirimiDefault(m);
    },
  }
};
</script>

<style scoped>
/* Dip toplamlar. Genel Toplam tablosu (tutar + KDV sutunu) ~415px; md4 sutunu
   1280px ekranda 324px'e iniyor ve tablo ekrandan tasiyor. */
.genel-toplam .kdv-alt { display: none; }
@media (min-width: 960px) {
  /* 415px tablo + 32px kenar boslugu; negatif margin'le sola cekmek tabloyu
     beyaz kartin disina tasiriyordu, onun yerine kart genisletildi */
  .dip-toplam-sutun { min-width: 450px; }
}
/* Telefonda KDV ayri sutuna sigmiyor; tutarin altina iner */
@media (max-width: 599px) {
  .genel-toplam .kdv-sutun { display: none; }
  .genel-toplam .kdv-alt { display: block; }
}
</style>
